<template>
    <div class="formDFD">
        <div class="form mb-3" style="min-height: 20vh;" v-if="lstEtapas">
            <div class="row">
                <div class="col-12 text-end mb-2">
                    <div v-if="emProcessamento" class="importacao-em-andamento-container">
                        <div class="importacao-em-andamento-card">
                            <div class="row">
                                <div class="col-12 col-md-2 m-auto">
                                    <div class="importacao-em-andamento-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M8 3a5 5 0 1 0 4.546 7.083.5.5 0 0 1 .908.418A6 6 0 1 1 8 2v1z" />
                                            <path d="M8 0a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-1 0V.5A.5.5 0 0 1 8 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="col-12 col-md-8 text-start">
                                    <h2>Processamento em andamento</h2>
                                    <p class="text-start">Existe um processamento em andamento. Aguarde a conclusão para gerar o documento.</p>
                                    <p v-if="podeCancelarProcessamento" class="text-start text-warning mb-0">
                                        O processamento parece travado. Você pode cancelá-lo e tentar novamente.
                                    </p>
                                </div>
                                <div class="col-12 col-md-2  m-auto">
                                    <div class="importacao-em-andamento-actions d-flex flex-column gap-2">
                                        <button class="btn btn-primary" @click="getStatusProcessamento">
                                            <span>Recarregar status</span>
                                        </button>
                                        <button v-if="podeCancelarProcessamento"
                                                class="btn btn-outline-warning"
                                                :disabled="cancelarProcessamentoLoading"
                                                @click="confirmarCancelarProcessamento">
                                            {{ cancelarProcessamentoLoading ? 'Cancelando...' : 'Cancelar processamento' }}
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <button v-if="!emProcessamento"
                            :class="(flPermissao?'btn btn-outline-primary':'btn btn-outline-light')"
                            @click="(flPermissao?buscarNoPncp():null)"
                            :disabled="!flPermissao">
                        Buscar no PNCP
                    </button>
                    <button v-if="!emProcessamento && temRequisicaoCompra"
                            :class="(flPermissao?'btn btn-outline-primary ms-3':'btn btn-outline-light ms-3')"
                            @click="(flPermissao?preencherPorRequisicao():null)"
                            :disabled="!flPermissao">
                        Preencher a partir da Requisição
                    </button>
                    <button  v-if="!emProcessamento"
                            :class="(flPermissao?'btn btn-primary ms-3':'btn btn-outline-light ms-3')"
                            @click="(flPermissao?preencherIA():null)"
                            :disabled="!flPermissao"
                            >Preencher com IA</button>
                </div>
            </div>
            <div class="dfd-conteudo" :class="{ 'dfd-conteudo--com-pncp': painelPncpAberto }">
                <div class="dfd-formulario">
            <div class="wizard-indicators mb-4">
                <div class="wizard-step"
                     v-for="(item, index) in lstEtapas"
                     :key="index"
                     :class="{active: index === indexFormulario,obrigatoria: index === indexUltimaEtapaAvancada,completed: index < indexUltimaEtapaAvancada}"
                     @click="navegarParaEtapa(index)">
                    <div class="circle">{{ index + 1 }}</div>
                    <div class="label">{{ item.dsTitulo }}</div>
                    <div class="line" v-if="index < lstEtapas.length - 1"></div>
                </div>


            </div>

            <div class="carousel-inner pb-5">
                <div :class="'carousel-item '+ (indexFormulario == 0?'active':'')">
                    <h5>1 - Descrição da necessidade da contratação, considerado o problema a ser resolvido sob a perspectiva do interesse público;</h5>
                    <span>Problema a ser resolvido sob a perspectiva do interesse público</span>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(9)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(9)+'-0'">
                            1.1 - Qual problema será resolvido ou qual a necessidade que será atendida com essa aquisição? Descreva de forma clara e objetiva.
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(9)+'-0']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(9)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(9)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(9)+'-0']"
                                  placeholder="Descreva de forma clara e objetiva o problema a ser resolvido..."></textarea>
                        <span>Exemplo: O município de Fortaleza possui 20 escolas de ensino fundamental, que atendem aproximadamente 10.000 crianças...</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(9)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(9)+'-1'">
                            1.2 - Como a resolução desse problema ou o atendimento dessa necessidade está alinhado ao interesse público?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(9)+'-1']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(9)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(9)+'-1'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(9)+'-1']"
                                  placeholder="Explique como a solução se alinha ao interesse público..."></textarea>
                        <span>Exemplo: A aquisição de materiais escolares é indispensável para a implementação do direito à educação, garantido pela Constituição Federal...</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(9)+'-2'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(9)+'-2'">
                            1.3 - Como a solução desse problema ou o atendimento dessa necessidade está conectada a um objetivo estratégico da sua organização? Caso não exista um planejamento estratégico formal, explique como isso contribui para um
                            serviço essencial à população, como saúde, educação ou segurança ou outro serviço definido na “Carta de Serviços ao Cidadão” do seu órgão/entidade.
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(9)+'-2']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(9)+'-2'" :name="getIdModeloArtefatoFormularioEtapa(9)+'-2'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(9)+'-2']"
                                  placeholder="Descreva a conexão com objetivos estratégicos ou serviços essenciais..."></textarea>
                        <span>Exemplo: O município de "X" definiu como objetivo estratégico 2025-2027 reduzir a evasão escolar em 10% em relação ao índice atual. O fornecimento adequado de materiais escolares contribui...</span>
                        <p class="d-none">
                            Observação: O ideal é que sejam citados documentos de suporte para essa afirmação, como um link para planejamento estratégico ou informado o arquivo/anexo em que esse documento pode ser encontrado.
                        </p>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(9)+'-3'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(9)+'-3'">
                            1.4 - Quais são os principais impactos negativos dessa necessidade/problema no atendimento à população?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(9)+'-3']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(9)+'-3'" :name="getIdModeloArtefatoFormularioEtapa(9)+'-3'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(9)+'-3']"
                                  placeholder="Considere aspectos como segurança, qualidade, continuidade do serviço público..."></textarea>
                        <span>Exemplo: A falta de materiais escolares prejudica o aprendizado dos alunos e pode levar muitos a abandonarem a escola. Isso impacta o futuro das crianças e a vida das comunidades...</span>
                    </div>
                </div>
                <div :class="'carousel-item '+ (indexFormulario == 1?'active':'')">
                    <h5>
                        2 - Descrição dos requisitos da contratação necessários e suficientes à escolha da solução, prevendo critérios e práticas de sustentabilidade, observadas as leis ou regulamentações específicas, bem como padrões mínimos de
                        qualidade e desempenho;
                    </h5>
                    <span>Especificações técnicas e sustentabilidade</span>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(10)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(10)+'-0'">
                            2.1 - Quais as características essenciais que o objeto ou serviço deve possuir para atender à necessidade identificada. Inclua especificações técnicas, funcionalidades e outros atributos indispensáveis, se for o caso.
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(10)+'-0']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(10)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(10)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(10)+'-0']"
                                  placeholder="Inclua especificações técnicas, funcionalidades e outros atributos indispensáveis..."></textarea>
                        <span>Exemplo: capacidade, eficiência energética, tipo de material utilizado, dimensões, etc.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient my-2">
                            2.2 Características de sustentabilidade
                        </p>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" :id="getIdModeloArtefatoFormularioEtapa(10)+'-2'" :name="getIdModeloArtefatoFormularioEtapa(10)+'-2'"
                                   v-model="respostas[getIdModeloArtefatoFormularioEtapa(10)+'-2']"
                                   true-value="Sim"
                                   false-value="Não">
                            <span class="d-none" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(10)+'-2'">
                                Características de sustentabilidade, Eficiência energética?
                            </span>
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(10)+'-2'">
                                Eficiência energética
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" :id="getIdModeloArtefatoFormularioEtapa(10)+'-3'" :name="getIdModeloArtefatoFormularioEtapa(10)+'-3'"
                                   v-model="respostas[getIdModeloArtefatoFormularioEtapa(10)+'-3']"
                                   true-value="Sim"
                                   false-value="Não">
                            <span class="d-none" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(10)+'-3'">
                                Características de sustentabilidade, Uso de materiais recicláveis?
                            </span>
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(10)+'-3'">
                                Uso de materiais recicláveis
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" :id="getIdModeloArtefatoFormularioEtapa(10)+'-4'" :name="getIdModeloArtefatoFormularioEtapa(10)+'-4'"
                                   v-model="respostas[getIdModeloArtefatoFormularioEtapa(10)+'-4']"
                                   true-value="Sim"
                                   false-value="Não">
                            <span class="d-none" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(10)+'-4'">
                                Características de sustentabilidade, Práticas sustentáveis no fornecimento?
                            </span>
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(10)+'-4'">
                                Práticas sustentáveis no fornecimento
                            </label>
                        </div>
                        <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(10)+'-2'] == 'Sim' || respostas[getIdModeloArtefatoFormularioEtapa(10)+'-3'] == 'Sim' || respostas[getIdModeloArtefatoFormularioEtapa(10)+'-4'] == 'Sim' ">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(10)+'-5'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(10)+'-5'">
                                Justificativa para as características de sustentabilidade
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(10)+'-5'" :name="getIdModeloArtefatoFormularioEtapa(10)+'-5'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(10)+'-5']"
                                      placeholder="Justifique as escolhas com base em normas ou diretrizes aplicáveis..."></textarea>
                            <span>Observação: características e práticas de sustentabilidade exigem justificativa. Justifique as escolhas com base em normas ou diretrizes aplicáveis.</span>
                            <p>
                                Exemplo: Guia Nacional de Contratações Sustentáveis.
                            </p>
                        </template>

                    </div>
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient my-2">
                            2.3 Exigências específicas à empresa contratada
                        </p>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" :id="getIdModeloArtefatoFormularioEtapa(10)+'-6'" :name="getIdModeloArtefatoFormularioEtapa(10)+'-6'"
                                   v-model="respostas[getIdModeloArtefatoFormularioEtapa(10)+'-6']"
                                   true-value="Sim"
                                   false-value="Não">
                            <span class="d-none" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(10)+'-6'">
                                Exigências específicas à empresa contratada, Prazo de entrega?
                            </span>
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(10)+'-6'">
                                Prazo de entrega
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" :id="getIdModeloArtefatoFormularioEtapa(10)+'-7'" :name="getIdModeloArtefatoFormularioEtapa(10)+'-7'"
                                   v-model="respostas[getIdModeloArtefatoFormularioEtapa(10)+'-7']"
                                   true-value="Sim"
                                   false-value="Não">
                            <span class="d-none" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(10)+'-7'">
                                Exigências específicas à empresa contratada, Abrangência geográfica?
                            </span>
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(10)+'-7'">
                                Abrangência geográfica
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" :id="getIdModeloArtefatoFormularioEtapa(10)+'-8'" :name="getIdModeloArtefatoFormularioEtapa(10)+'-8'"
                                   v-model="respostas[getIdModeloArtefatoFormularioEtapa(10)+'-8']"
                                   true-value="Sim"
                                   false-value="Não">
                            <span class="d-none" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(10)+'-8'">
                                Exigências específicas à empresa contratada, Capacidade técnica?
                            </span>
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(10)+'-8'">
                                Capacidade técnica
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" :id="getIdModeloArtefatoFormularioEtapa(10)+'-9'" :name="getIdModeloArtefatoFormularioEtapa(10)+'-9'"
                                   v-model="respostas[getIdModeloArtefatoFormularioEtapa(10)+'-9']"
                                   true-value="Sim"
                                   false-value="Não">
                            <span class="d-none" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(10)+'-9'">
                                Exigências específicas à empresa contratada, Certificações?
                            </span>
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(10)+'-9'">
                                Certificações
                            </label>
                        </div>
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(10)+'-10'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(10)+'-10'">
                            Outras exigências específicas
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(10)+'-10'" :name="getIdModeloArtefatoFormularioEtapa(10)+'-10'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(10)+'-10']"
                                  placeholder="Descreva outras exigências específicas..."></textarea>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(10)+'-11'">
                            Sistema de Registro de Preços (SRP)
                        </p>
                        <div class="form-check">
                            <input class="form-check-input" value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(10)+'-11'"
                                   :name="getIdModeloArtefatoFormularioEtapa(10)+'-11'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(10)+'-11']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(10)+'-11'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input" value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(10)+'-11'"
                                   :name="getIdModeloArtefatoFormularioEtapa(10)+'-11'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(10)+'-11']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(10)+'-11'">
                                Não
                            </label>
                        </div>
                        <span class="d-none">
                            Exemplo: Outros órgãos poderão aderir à ata de registro de preços? Haverá outros órgãos participantes na origem do processo?
                        </span>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(10)+'-11'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(10)+'-12'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(10)+'-12'">
                                Inciso do art. 3º do Decreto 11.462/2023
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(10)+'-12'" :name="getIdModeloArtefatoFormularioEtapa(10)+'-12'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(10)+'-12']"
                                      placeholder="Informe o inciso que justifica a escolha..."></textarea>

                        </div>
                    </template>

                </div>
                <div :class="'carousel-item '+ (indexFormulario == 2?'active':'')">
                    <h5>
                        3 - Levantamento de mercado, que consiste na análise das alternativas possíveis, e justificativa técnica e econômica da escolha do tipo de solução a contratar, podendo, entre outras opções:
                    </h5>
                    <span>Análise de alternativas e justificativas</span>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(11)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(11)+'-0'">
                            3.1 - Quais alternativas foram identificadas no mercado para atender à necessidade descrita?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(11)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(11)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-0']"
                                  placeholder=""></textarea>
                        <span>Exemplo: Aquisição de bens, locação, desenvolvimento interno, parcerias público-privadas...</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(11)+'-1'">
                            3.2 - Foram consideradas contratações similares feitas por outros órgãos públicos ou entidades privadas?
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(11)+'-1'"
                                   :name="getIdModeloArtefatoFormularioEtapa(11)+'-1'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-1']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(11)+'-1'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(11)+'-1'"
                                   :name="getIdModeloArtefatoFormularioEtapa(11)+'-1'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-1']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(11)+'-1'">
                                Não
                            </label>
                        </div>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-1'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(11)+'-2'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(11)+'-2'">
                                3.2.1 - Quais contratações serviram de referência? Informe o número do pregão e da UASG.
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(11)+'-2'" :name="getIdModeloArtefatoFormularioEtapa(11)+'-2'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-2']"
                                      placeholder=""></textarea>
                        </div>
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(11)+'-3'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(11)+'-3'">
                                3.2.2 - Quais soluções foram identificadas?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(11)+'-3'" :name="getIdModeloArtefatoFormularioEtapa(11)+'-3'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-3']"
                                      placeholder=""></textarea>
                        </div>
                    </template>

                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(11)+'-4'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(11)+'-4'">
                            3.3 - Identificou inovações ou novas tecnologias que podem atender melhor à necessidade da Administração?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(11)+'-4'" :name="getIdModeloArtefatoFormularioEtapa(11)+'-4'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-4']"
                                  placeholder=""></textarea>
                        <span>Exemplo: automação de processos, novos materiais ou metodologias mais eficientes.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(11)+'-5'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(11)+'-5'">
                            3.4 - Qual é a justificativa técnica para a escolha da solução proposta?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(11)+'-5'" :name="getIdModeloArtefatoFormularioEtapa(11)+'-5'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-5']"
                                  placeholder=""></textarea>
                        <span>
                            Exemplo: Tecnologias de domínio amplo (evitar tecnologias de domínio restrito ou soluções próximas da obsolescência), especificações que atendem com maior aderência aos requisitos do cliente interno ou que possuam maior vantajosidade no atendimento da necessidade.
                        </span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(11)+'-6'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(11)+'-6'">
                            3.5 - Qual é a justificativa econômica para a escolha da solução proposta?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(11)+'-6'" :name="getIdModeloArtefatoFormularioEtapa(11)+'-6'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-6']"
                                  placeholder=""></textarea>
                        <span>Exemplo: Menor custo, maior durabilidade, benefícios adicionais ao longo do ciclo de vida do objeto.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(11)+'-7'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(11)+'-7'">
                            3.6 - Quais os custos e benefícios de cada alternativa? Quais critérios foram utilizados para essa análise? Qual foi a alternativa considerada mais vantajosa para a Administração, levando em consideração custos e
                            benefícios diretos e indiretos?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(11)+'-7'" :name="getIdModeloArtefatoFormularioEtapa(11)+'-7'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-7']"
                                  placeholder=""></textarea>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(11)+'-8'">
                            3.7 - Foi realizada audiência ou consulta pública para coletar contribuições sobre a necessidade ou solução proposta?
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(11)+'-8'"
                                   :name="getIdModeloArtefatoFormularioEtapa(11)+'-8'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-8']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(11)+'-8'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(11)+'-8'"
                                   :name="getIdModeloArtefatoFormularioEtapa(11)+'-8'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-8']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(11)+'-8'">
                                Não
                            </label>
                        </div>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-8'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(11)+'-9'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(11)+'-9'">
                                3.7.1 - Como foi realizada e quais os resultados?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(11)+'-9'" :name="getIdModeloArtefatoFormularioEtapa(11)+'-9'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-9']"
                                      placeholder=""></textarea>
                        </div>
                    </template>

                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(11)+'-10'">
                            3.8 - Considerou-se alguma alternativa logística menos onerosa para atender à necessidade?
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(11)+'-10'"
                                   :name="getIdModeloArtefatoFormularioEtapa(11)+'-10'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-10']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(11)+'-10'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(11)+'-10'"
                                   :name="getIdModeloArtefatoFormularioEtapa(11)+'-10'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-10']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(11)+'-10'">
                                Não
                            </label>
                        </div>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-10'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(11)+'-11'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(11)+'-11'">
                                3.8.1 - Quais foram analisadas?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(11)+'-11'" :name="getIdModeloArtefatoFormularioEtapa(11)+'-11'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-11']"
                                      placeholder=""></textarea>
                            <span>Exemplo: Chamamentos públicos de doação, permutas ou parcerias...</span>
                        </div>
                    </template>
                    <template v-else-if="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-10'] == 'Não'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(11)+'-12'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(11)+'-12'">
                                3.8.1 - Justifique por que essas opções não foram viáveis.
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(11)+'-12'" :name="getIdModeloArtefatoFormularioEtapa(11)+'-12'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-12']"
                                      placeholder=""></textarea>
                        </div>
                    </template>

                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(11)+'-13'">
                            3.9 - Houve avaliação de arranjos inovadores ou práticas de economia circular para atender à necessidade?
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(11)+'-13'"
                                   :name="getIdModeloArtefatoFormularioEtapa(11)+'-13'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-13']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(11)+'-13'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(11)+'-13'"
                                   :name="getIdModeloArtefatoFormularioEtapa(11)+'-13'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-13']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(11)+'-13'">
                                Não
                            </label>
                        </div>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-13'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(11)+'-14'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(11)+'-14'">
                                3.9.1 - Quais práticas foram consideradas?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(11)+'-14'" :name="getIdModeloArtefatoFormularioEtapa(11)+'-14'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-14']"
                                      placeholder=""></textarea>
                            <span>Exemplo: Reutilização de bens, aquisição de materiais recicláveis ou contratos baseados em desempenho...</span>
                        </div>
                    </template>
                    <template v-else-if="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-13'] == 'Não'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(11)+'-15'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(11)+'-15'">
                                3.9.1 - Explique por que não foram aplicadas.
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(11)+'-15'" :name="getIdModeloArtefatoFormularioEtapa(11)+'-15'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(11)+'-15']"
                                      placeholder=""></textarea>
                        </div>
                    </template>

                </div>
                <div :class="'carousel-item '+ (indexFormulario == 3?'active':'')">
                    <h5>
                        4 - Descrição da solução como um todo, inclusive das exigências relacionadas à manutenção e à assistência técnica, quando for o caso;
                    </h5>
                    <span>Modalidade de licitação e exigências</span>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-0'">
                            4.1 - Qual a solução escolhida entre as opções analisadas?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(12)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-0']"
                                  placeholder=""></textarea>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-1'">
                            4.2 - Foram identificadas empresas que podem entregar a solução da forma como foi planejada?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(12)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-1'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-1']"
                                  placeholder=""></textarea>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-2'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-2'">
                            4.3 - Informe nome e porte das empresas identificadas (MEI, ME, EPP).
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(12)+'-2'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-2'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-2']"
                                  placeholder=""></textarea>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-3'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-3'">
                            4.4 - Quais documentos de suporte foram inseridos dentro do processo que comprovam a existem de empresas capazes de entregar o objeto?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(12)+'-3'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-3'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-3']"
                                  placeholder=""></textarea>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-4'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-4'">
                            4.5 - Foram identificados objetos que podem atender as especificações do cliente?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(12)+'-4'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-4'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-4']"
                                  placeholder=""></textarea>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-5'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-5'">
                            4.6 - Qual será a modalidade de licitação e por que ela foi escolhida?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(12)+'-5'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-5'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-5']"
                                  placeholder=""></textarea>
                        <span>Exemplo: Pregão eletrônico devido à sua aplicabilidade para bens e serviços comuns.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-6'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-6'">
                            4.7 - Qual será o critério de julgamento e como ele se adequa ao objeto da contratação?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(12)+'-6'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-6'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-6']"
                                  placeholder=""></textarea>
                        <span>Exemplo: Menor preço para bens e serviços com especificações técnicas claras.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-7'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-7'">
                            4.8 - Qual será o modo de disputa e por que ele é o mais adequado para este processo?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(12)+'-7'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-7'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-7']"
                                  placeholder=""></textarea>
                        <span>Exemplo: Modo aberto ou combinado para maximizar a competitividade.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-8'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-8'">
                            4.9 - Quais exigências de qualificação técnica serão necessárias e como elas se justificam?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(12)+'-8'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-8'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-8']"
                                  placeholder=""></textarea>
                        <span>Exemplo: Atestados de capacidade técnica específicos para itens de maior relevância.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-9'">
                            4.10 - Houve exigência de amostras ou prova de conceito?
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(12)+'-9'"
                                   :name="getIdModeloArtefatoFormularioEtapa(12)+'-9'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-9']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(12)+'-9'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(12)+'-9'"
                                   :name="getIdModeloArtefatoFormularioEtapa(12)+'-9'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-9']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(12)+'-9'">
                                Não
                            </label>
                        </div>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-9'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-10'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-10'">
                                4.10.1 - Qual a justificativa?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(12)+'-10'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-10'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-10']"
                                      placeholder=""></textarea>
                            <span>Exemplo: Garantir a qualidade e a aderência às especificações do objeto.</span>
                        </div>
                    </template>

                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-11'">
                            4.11 - Será exigida marca e modelo?
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(12)+'-11'"
                                   :name="getIdModeloArtefatoFormularioEtapa(12)+'-11'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-11']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(12)+'-11'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(12)+'-11'"
                                   :name="getIdModeloArtefatoFormularioEtapa(12)+'-11'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-11']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(12)+'-11'">
                                Não
                            </label>
                        </div>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-11'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-12'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-12'">
                                4.11.1 - Qual a justificativa?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(12)+'-12'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-12'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-12']"
                                      placeholder=""></textarea>
                            <span>Exemplo: O mercado já dispõe de empresas individuais capacitadas para atender ao objeto.</span>
                        </div>
                    </template>
                    <!---->
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-13'">
                            4.12 - Será vedada a participação de empresas em consórcio?
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(12)+'-13'"
                                   :name="getIdModeloArtefatoFormularioEtapa(12)+'-13'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-13']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(12)+'-13'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(12)+'-13'"
                                   :name="getIdModeloArtefatoFormularioEtapa(12)+'-13'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-13']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(12)+'-13'">
                                Não
                            </label>
                        </div>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-13'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-14'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-14'">
                                4.12.1 - Qual a justificativa?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(12)+'-14'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-14'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-14']"
                                      placeholder=""></textarea>
                        </div>
                    </template>
                    <!---->
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-15'">
                            4.13 - Será permitida a participação de pessoas físicas?
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(12)+'-15'"
                                   :name="getIdModeloArtefatoFormularioEtapa(12)+'-15'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-15']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(12)+'-15'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(12)+'-15'"
                                   :name="getIdModeloArtefatoFormularioEtapa(12)+'-15'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-15']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(12)+'-15'">
                                Não
                            </label>
                        </div>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-15'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-16'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-16'">
                                4.13.1 - Quais requisitos serão exigidos?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(12)+'-16'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-16'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-16']"
                                      placeholder=""></textarea>
                            <span>Exemplo: O mercado já dispõe de empresas individuais capacitadas para atender ao objeto.</span>
                        </div>
                    </template>
                    <!---->
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-17'">
                            4.14 - Os itens a serem adquiridos possuem características de artigos de luxo?
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(12)+'-17'"
                                   :name="getIdModeloArtefatoFormularioEtapa(12)+'-17'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-17']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(12)+'-17'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(12)+'-17'"
                                   :name="getIdModeloArtefatoFormularioEtapa(12)+'-17'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-17']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(12)+'-17'">
                                Não
                            </label>
                        </div>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-17'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-18'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-18'">
                                4.14.1 - Quais requisitos serão exigidos?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(12)+'-18'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-18'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-18']"
                                      placeholder=""></textarea>
                        </div>
                    </template>
                    <!---->
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-19'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-19'">
                            4.15 - Foi realizada a análise de valores para limitar o processo licitatório ou um item ou grupo para MEI/ME/EPP e equiparadas? 
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(12)+'-19'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-19'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-19']"
                                  placeholder=""></textarea>
                        <span>Considere as disposições dos artigos 47 a 49 da Lei Complementar 123/2006.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-20'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-20'">
                            4.16 - O fornecimento será contínuo? Caso positivo, quais exigências de qualificação técnica e econômico-financeira serão aplicadas?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(12)+'-20'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-20'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-20']"
                                  placeholder=""></textarea>
                        <span>Exemplo: índices de liquidez, solvência e atestados específicos.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-21'">
                            4.17 - A solução contratada exigirá serviços de manutenção ou assistência técnica?
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(12)+'-21'"
                                   :name="getIdModeloArtefatoFormularioEtapa(12)+'-21'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-21']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(12)+'-21'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(12)+'-21'"
                                   :name="getIdModeloArtefatoFormularioEtapa(12)+'-21'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-21']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(12)+'-21'">
                                Não
                            </label>
                        </div>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-21'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-22'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-22'">
                                4.18 - Quais serão as condições mínimas exigidas para os serviços de manutenção e assistência técnica?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(12)+'-22'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-22'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-22']"
                                      placeholder=""></textarea>
                            <span>Exemplo: prazos de atendimento, frequência de manutenções preventivas etc.</span>
                        </div>
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-23'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-23'">
                                4.19 - Os serviços de manutenção ou assistência técnica deverão ser prestados mediante deslocamento de técnico até o local em que está o equipamento?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(12)+'-23'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-23'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-23']"
                                      placeholder=""></textarea>
                            <span>Se for exigido deslocamento, justifique como isso atende às necessidades da Administração. </span>
                        </div>
                        <div class="form-group ps-2 pb-2">
                            <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-24'">
                                4.20 - Será exigido que os serviços de manutenção ou assistência técnica sejam garantidos por um período específico?
                            </p>
                            <div class="form-check">
                                <input class="form-check-input" value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(12)+'-24'"
                                       :name="getIdModeloArtefatoFormularioEtapa(12)+'-24'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-24']">
                                <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(12)+'-24'">
                                    Sim
                                </label>
                            </div>
                            <div class="form-check mt-1">
                                <input class="form-check-input" value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(12)+'-24'"
                                       :name="getIdModeloArtefatoFormularioEtapa(12)+'-24'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-24']">
                                <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(12)+'-24'">
                                    Não
                                </label>
                            </div>
                        </div>
                        <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-24'] == 'Sim'">
                            <div class="form-group ps-2 pb-2">
                                <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(12)+'-25'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(12)+'-25'">
                                    4.20.1 - Qual será o período de garantia mínimo exigido?
                                </label>
                                <textarea class="form-control mt-1"
                                          rows="2"
                                          :id="getIdModeloArtefatoFormularioEtapa(12)+'-25'" :name="getIdModeloArtefatoFormularioEtapa(12)+'-25'"
                                          v-model="respostas[getIdModeloArtefatoFormularioEtapa(12)+'-25']"
                                          placeholder=""></textarea>
                                <span>Exemplo: 12 meses, 24 meses.</span>
                            </div>
                        </template>
                    </template>
                    <!----><!----><!----><!---->
                </div>
                <div :class="'carousel-item '+ (indexFormulario == 4?'active':'')">
                    <h5>
                        5 - Estimativa das quantidades a serem contratadas, acompanhada das memórias de cálculo e dos documentos que lhe dão suporte, considerando a interdependência com outras contratações, de modo a possibilitar economia de
                        escala;
                    </h5>
                    <span>Itens e memórias de cálculo</span>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(13)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(13)+'-0'">
                            5.1 - Quais são os itens que serão contratados e suas respectivas quantidades estimadas?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(13)+'-0']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(13)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(13)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(13)+'-0']"
                                  placeholder=""></textarea>
                        <span v-if="itensDetalhados == null || itensDetalhados.length == 0">Dica: Cadastre os itens do processo para que os dados sejam carregados automaticamente</span>
                        <span>(Inclua informações como descrições, unidades de medida e quantidades total por item.)</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(13)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(13)+'-1'">
                            5.2 - Quais dados foram utilizados para elaborar a memória de cálculo das quantidades?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(13)+'-1']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(13)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(13)+'-1'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(13)+'-1']"
                                  placeholder=""></textarea>
                        <span>Exemplo: histórico de consumo, contratos anteriores, projeções futuras.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(13)+'-2'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(13)+'-2'">
                            5.3 - Como foi realizada a memória de cálculo para definir os quantitativos?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(13)+'-2']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(13)+'-2'" :name="getIdModeloArtefatoFormularioEtapa(13)+'-2'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(13)+'-2']"
                                  placeholder=""></textarea>
                        <span>Descreva o método ou ferramenta utilizada, como planilhas, softwares ou análise de série histórica.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(13)+'-3'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(13)+'-3'">
                            5.4 - Quais documentos foram utilizados para validar os dados apresentados na memória de cálculo?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(13)+'-3']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(13)+'-3'" :name="getIdModeloArtefatoFormularioEtapa(13)+'-3'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(13)+'-3']"
                                  placeholder=""></textarea>
                        <span>Exemplo: relatórios de consumo, capturas de tela de sistemas de estoque, estudos de demanda.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(13)+'-4'">
                            5.5 - Os quantitativos a serem adquiridos estão acima do consumo histórico?
                            <span>*</span>
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(13)+'-4']) }"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(13)+'-4'"
                                   :name="getIdModeloArtefatoFormularioEtapa(13)+'-4'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(13)+'-4']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(13)+'-4'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(13)+'-4']) }"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(13)+'-4'"
                                   :name="getIdModeloArtefatoFormularioEtapa(13)+'-4'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(13)+'-4']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(13)+'-4'">
                                Não
                            </label>
                        </div>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(13)+'-4'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(13)+'-5'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(13)+'-5'">
                                5.5.1 - Qual a justificativa?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(13)+'-5'" :name="getIdModeloArtefatoFormularioEtapa(13)+'-5'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(13)+'-5']"
                                      placeholder=""></textarea>
                            <span>Exemplo: aumento de procedimentos, expansão de serviços, novos contratos.</span>
                        </div>
                    </template>
                    <!---->
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(13)+'-6'">
                            5.6 - Houve consideração da interdependência com outras contratações?
                            <span>*</span>
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(13)+'-6']) }"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(13)+'-6'"
                                   :name="getIdModeloArtefatoFormularioEtapa(13)+'-6'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(13)+'-6']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(13)+'-6'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(13)+'-6']) }"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(13)+'-6'"
                                   :name="getIdModeloArtefatoFormularioEtapa(13)+'-6'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(13)+'-6']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(13)+'-6'">
                                Não
                            </label>
                        </div>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(13)+'-6'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(13)+'-7'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(13)+'-7'">
                                5.6.1 - Descreva como isso foi avalidado.
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(13)+'-7'" :name="getIdModeloArtefatoFormularioEtapa(13)+'-7'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(13)+'-7']"
                                      placeholder=""></textarea>
                            <span>Exemplo: economia de escala, contratos compartilhados entre unidades.</span>
                        </div>
                    </template>
                    <!---->
                </div>
                <div :class="'carousel-item '+ (indexFormulario == 5?'active':'')">
                    <h5>
                        6 - Estimativa do valor da contratação, acompanhada dos preços unitários referenciais, das memórias de cálculo e dos documentos que lhe dão suporte, que poderão constar de anexo classificado, se a Administração optar por
                        preservar o seu sigilo até a conclusão da licitação;
                    </h5>
                    <span>Preços unitários e documentos de suporte</span>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(14)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(14)+'-0'">
                            6.1 - Qual o nome ou descrição detalhada do(s) item(ens) a ser(em) contratado(s)?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(14)+'-0']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(14)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(14)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(14)+'-0']"
                                  placeholder=""></textarea>
                        <span v-if="itensDetalhados == null || itensDetalhados.length == 0">Dica: Cadastre os itens do processo para que os dados sejam carregados automaticamente</span>
                        <span>Exemplo: luva para procedimento, tamanho médio, látex natural.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(14)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(14)+'-1'">
                            6.2 - Qual a unidade de medida do item?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(14)+'-1']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(14)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(14)+'-1'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(14)+'-1']"
                                  placeholder=""></textarea>
                        <span v-if="itensDetalhados == null || itensDetalhados.length == 0">Dica: Cadastre os itens do processo para que os dados sejam carregados automaticamente</span>
                        <span>Exemplo: caixa com 100 unidades, metro cúbico, litro, etc.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(14)+'-2'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(14)+'-2'">
                            6.3 - Qual a quantidade estimada de cada item?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(14)+'-2']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(14)+'-2'" :name="getIdModeloArtefatoFormularioEtapa(14)+'-2'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(14)+'-2']"
                                  placeholder=""></textarea>
                        <span v-if="itensDetalhados == null || itensDetalhados.length == 0">Dica: Cadastre os itens do processo para que os dados sejam carregados automaticamente</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(14)+'-3'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(14)+'-3'">
                            6.4 - Quais foram os preços unitários coletados para cada item?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(14)+'-3']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(14)+'-3'" :name="getIdModeloArtefatoFormularioEtapa(14)+'-3'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(14)+'-3']"
                                  placeholder=""></textarea>
                        <span v-if="itensDetalhados == null || itensDetalhados.length == 0">Dica: Cadastre os itens do processo para que os dados sejam carregados automaticamente</span>
                        <span>Exemplo: R$ 25,00 por caixa – Fornecedor A, R$ 24,50, pregão 123/2025, UASG 154234</span>
                    </div>
                </div>
                <div :class="'carousel-item '+ (indexFormulario == 6?'active':'')">
                    <h5>7 - Justificativas para o parcelamento ou não da solução;</h5>
                    <span>Decisões sobre divisão em lotes</span>
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(15)+'-0'">
                            7.1 - A solução será parcelada (por itens ou grupos)?
                            <span>*</span>
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(15)+'-0']) }"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(15)+'-0'"
                                   :name="getIdModeloArtefatoFormularioEtapa(15)+'-0'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-0']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(15)+'-0'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(15)+'-0']) }"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(15)+'-0'"
                                   :name="getIdModeloArtefatoFormularioEtapa(15)+'-0'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-0']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(15)+'-0'">
                                Não
                            </label>
                        </div>
                        <span>Informe se os itens serão licitados individualmente ou agrupados.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(15)+'-5'">
                            7.2 - Quais critérios foram considerados para decidir pelo parcelamento ou não da solução?
                        </p>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" :id="getIdModeloArtefatoFormularioEtapa(15)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(15)+'-1'"
                                   v-model="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-1']"
                                   true-value="Sim"
                                   false-value="Não">
                            <span class="d-none" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(15)+'-1'">
                                Quais critérios foram considerados para decidir pelo parcelamento ou não da solução, Viabilidade de divisão em lotes?
                            </span>
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(15)+'-1'">
                                Viabilidade de divisão em lotes
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" :id="getIdModeloArtefatoFormularioEtapa(15)+'-2'" :name="getIdModeloArtefatoFormularioEtapa(15)+'-2'"
                                   v-model="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-2']"
                                   true-value="Sim"
                                   false-value="Não">
                            <span class="d-none" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(15)+'-2'">
                                Quais critérios foram considerados para decidir pelo parcelamento ou não da solução, Peculiaridades do mercado local?
                            </span>
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(15)+'-2'">
                                Peculiaridades do mercado local
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" :id="getIdModeloArtefatoFormularioEtapa(15)+'-3'" :name="getIdModeloArtefatoFormularioEtapa(15)+'-3'"
                                   v-model="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-3']"
                                   true-value="Sim"
                                   false-value="Não">
                            <span class="d-none" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(15)+'-3'">
                                Quais critérios foram considerados para decidir pelo parcelamento ou não da solução, Ampliação da competição?
                            </span>
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(15)+'-3'">
                                Ampliação da competição
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" :id="getIdModeloArtefatoFormularioEtapa(15)+'-4'" :name="getIdModeloArtefatoFormularioEtapa(15)+'-4'"
                                   v-model="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-4']"
                                   true-value="Sim"
                                   false-value="Não">
                            <span class="d-none" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(15)+'-4'">
                                Quais critérios foram considerados para decidir pelo parcelamento ou não da solução, Concentração de mercado ?
                            </span>
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(15)+'-4'">
                                Concentração de mercado
                            </label>
                        </div>
                        <span class="d-none" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(15)+'-5'">
                            Outros critérios considerados:
                        </span>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(15)+'-5'" :name="getIdModeloArtefatoFormularioEtapa(15)+'-5'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-5']"
                                  placeholder="Outros critérios considerados..."></textarea>
                    </div>

                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-0'] == 'Sim'">
                        <div class="alert alert-primary" role="alert">
                            <h5 class="text-primary">Justificativa para o Parcelamento</h5>
                            <div class="form-group ps-2 pb-2">
                                <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(15)+'-6'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(15)+'-6'">
                                    7.3 - Qual a justificativa para o agrupamento dos itens em cada lote?
                                </label>
                                <textarea class="form-control mt-1" style="background-color: var(--bs-alert-bg)"
                                          rows="2"
                                          :id="getIdModeloArtefatoFormularioEtapa(15)+'-6'" :name="getIdModeloArtefatoFormularioEtapa(15)+'-6'"
                                          v-model="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-6']"
                                          placeholder=""></textarea>
                                <span>Descreva como a formação dos grupos favorece a economicidade e competitividade.</span>
                            </div>
                            <div class="form-group ps-2 pb-2">
                                <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(15)+'-7'">
                                    7.4 - Os itens agrupados são vendidos por fornecedores que geralmente comercializam todos os itens do grupo?
                                </p>
                                <div class="form-check">
                                    <input class="form-check-input" value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(15)+'-7'"
                                           :name="getIdModeloArtefatoFormularioEtapa(15)+'-7'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-7']">
                                    <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(15)+'-7'">
                                        Sim
                                    </label>
                                </div>
                                <div class="form-check mt-1">
                                    <input class="form-check-input" value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(15)+'-7'"
                                           :name="getIdModeloArtefatoFormularioEtapa(15)+'-7'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-7']">
                                    <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(15)+'-7'">
                                        Não
                                    </label>
                                </div>
                            </div>
                            <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-7'] == 'Não'">
                                <div class="form-group ps-2 pb-2">
                                    <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(15)+'-8'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(15)+'-8'">
                                        Explique como isso influencia a competitividade e a execução do contrato
                                    </label>
                                    <textarea class="form-control mt-1" style="background-color: var(--bs-alert-bg)"
                                              rows="2"
                                              :id="getIdModeloArtefatoFormularioEtapa(15)+'-8'" :name="getIdModeloArtefatoFormularioEtapa(15)+'-8'"
                                              v-model="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-8']"
                                              placeholder=""></textarea>
                                </div>

                            </template>
                        </div>

                    </template>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-0'] == 'Não'">
                        <div class="alert alert-success" role="alert">
                            <h5 class="text-success">JustifiSimcativa para Não Parcelar</h5>
                            <div class="form-group ps-2 pb-2">
                                <p class="gradient-text text-dark color-gradient mt-2">
                                    7.5 - Qual a justificativa para manter os itens em um único lote?
                                </p>

                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" :id="getIdModeloArtefatoFormularioEtapa(15)+'-9'" :name="getIdModeloArtefatoFormularioEtapa(15)+'-9'"
                                           v-model="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-9']"
                                           true-value="Sim"
                                           false-value="Não">
                                    <span class="d-none" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(15)+'-9'">
                                        Qual a justificativa para manter os itens em um único lote, Economia de escala?
                                    </span>
                                    <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(15)+'-9'">
                                        Economia de escala
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" :id="getIdModeloArtefatoFormularioEtapa(15)+'-10'" :name="getIdModeloArtefatoFormularioEtapa(15)+'-10'"
                                           v-model="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-10']"
                                           true-value="Sim"
                                           false-value="Não">
                                    <span class="d-none" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(15)+'-10'">
                                        Qual a justificativa para manter os itens em um único lote, Redução de custos de gestão de contratos?
                                    </span>
                                    <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(15)+'-10'">
                                        Redução de custos de gestão de contratos
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" :id="getIdModeloArtefatoFormularioEtapa(15)+'-11'" :name="getIdModeloArtefatoFormularioEtapa(15)+'-11'"
                                           v-model="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-11']"
                                           true-value="Sim"
                                           false-value="Não">
                                    <span class="d-none" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(15)+'-11'">
                                        Qual a justificativa para manter os itens em um único lote, Sistema único e integrado?
                                    </span>
                                    <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(15)+'-11'">
                                        Sistema único e integrado
                                    </label>
                                </div>
                                <span class="d-none" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(15)+'-12'">
                                    Outras justificativas para não parcelar:
                                </span>
                                <textarea class="form-control mt-2" style="background-color: var(--bs-alert-bg)"
                                          rows="2"
                                          :id="getIdModeloArtefatoFormularioEtapa(15)+'-12'" :name="getIdModeloArtefatoFormularioEtapa(15)+'-12'"
                                          v-model="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-12']"
                                          placeholder="Outras justificativas para não parcelar..."></textarea>
                            </div>
                        </div>

                    </template>
                    <!----><!----><!---->
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(15)+'-13'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(15)+'-13'">
                            7.6 - A decisão de parcelar ou não a solução atende ao objetivo de evitar concentração de mercado e ampliar a competição?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(15)+'-13']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(15)+'-13'" :name="getIdModeloArtefatoFormularioEtapa(15)+'-13'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-13']"
                                  placeholder=""></textarea>
                        <span>Justifique como a decisão contribui para esses objetivos.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(15)+'-14'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(15)+'-14'">
                            7.7 - Houve análise das peculiaridades do mercado local para essa decisão?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(15)+'-14']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(15)+'-14'" :name="getIdModeloArtefatoFormularioEtapa(15)+'-14'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(15)+'-14']"
                                  placeholder=""></textarea>
                        <span>Explique como o mercado local influenciou a formação dos lotes ou a decisão de manter um único grupo.</span>
                    </div>
                </div>
                <div :class="'carousel-item '+ (indexFormulario == 7?'active':'')">
                    <h5>8 - Contratações correlatas e/ou interdependentes;</h5>
                    <span>Interdependências e correlações</span>
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(16)+'-0'">
                            8.1 - A contratação principal depende de outra contratação para produzir seus efeitos?
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(16)+'-0'"
                                   :name="getIdModeloArtefatoFormularioEtapa(16)+'-0'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(16)+'-0']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(16)+'-0'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(16)+'-0'"
                                   :name="getIdModeloArtefatoFormularioEtapa(16)+'-0'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(16)+'-0']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(16)+'-0'">
                                Não
                            </label>
                        </div>
                        <span>Exemplo: aquisição de insumos específicos para o funcionamento de um equipamento.</span>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(16)+'-0'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(16)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(16)+'-1'">
                                8.1.1 - Quais medidas serão tomadas para garantir a compatibilidade entre a contratação principal e as contratações interdependentes?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(16)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(16)+'-1'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(16)+'-1']"
                                      placeholder=""></textarea>
                            <span>Exemplo: tipo de insumo necessário, frequência de aquisição, valores estimados.</span>
                        </div>
                    </template>
                    <!---->
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(16)+'-2'">
                            8.2 - Existem contratações que não são indispensáveis, mas que podem potencializar os resultados da contratação principal?
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(16)+'-2'"
                                   :name="getIdModeloArtefatoFormularioEtapa(16)+'-2'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(16)+'-2']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(16)+'-2'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(16)+'-2'"
                                   :name="getIdModeloArtefatoFormularioEtapa(16)+'-2'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(16)+'-2']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(16)+'-2'">
                                Não
                            </label>
                        </div>
                        <span>Exemplo: contratos de manutenção preventiva, seguros, treinamentos.</span>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(16)+'-2'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(16)+'-3'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(16)+'-3'">
                                8.2.1 - Descreva essas contratações correlatas e como elas contribuirão para a eficácia da contratação principal.
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(16)+'-3'" :name="getIdModeloArtefatoFormularioEtapa(16)+'-3'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(16)+'-3']"
                                      placeholder=""></textarea>
                        </div>
                    </template>
                    <!---->
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(16)+'-4'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(16)+'-4'">
                            8.3 - As contratações correlatas têm impacto significativo no custo-benefício da contratação principal?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(16)+'-4'" :name="getIdModeloArtefatoFormularioEtapa(16)+'-4'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(16)+'-4']"
                                  placeholder=""></textarea>
                        <span>Justifique como elas agregam valor ao processo.</span>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(16)+'-2'] == 'Não'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(16)+'-5'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(16)+'-5'">
                                8.4 - Caso não existam contratações correlatas ou interdependentes, declare isso explicitamente.
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(16)+'-5'" :name="getIdModeloArtefatoFormularioEtapa(16)+'-5'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(16)+'-5']"
                                      placeholder=""></textarea>
                            <span>Exemplo: "A contratação principal é autossuficiente e não depende de outras contratações para produzir seus efeitos."</span>
                        </div>
                    </template>
                    <!---->
                </div>
                <div :class="'carousel-item '+ (indexFormulario == 8?'active':'')">
                    <h5>
                        9 - Demonstrativo da previsão da contratação no Plano de Contratações Anual, de modo a indicar o seu alinhamento com os instrumentos de planejamento do órgão ou entidade;
                    </h5>
                    <span>Alinhamento com instrumentos de planejamento</span>
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(17)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(17)+'-0'">
                            9.1 - A contratação está prevista no Plano de Contratações Anual (PCA)?
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(17)+'-0'"
                                   :name="getIdModeloArtefatoFormularioEtapa(17)+'-0'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(17)+'-0']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(17)+'-0'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(17)+'-0'"
                                   :name="getIdModeloArtefatoFormularioEtapa(17)+'-0'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(17)+'-0']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(17)+'-0'">
                                Não
                            </label>
                        </div>
                        <span>Exemplo: "Item 12 do PCA 2025 – Contratação de insumos hospitalares."</span>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(17)+'-0'] == 'Não'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(17)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(17)+'-1'">
                                9.2 - Caso a contratação não esteja no PCA, qual a justificativa para sua ausência?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(17)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(17)+'-1'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(17)+'-1']"
                                      placeholder=""></textarea>
                            <span>Exemplo: demanda emergente, alteração de prioridades, entre outros.</span>
                        </div>
                    </template>

                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(17)+'-2'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(17)+'-2'">
                            9.3 - O órgão optou por não elaborar o PCA para o ano vigente? Caso sim, informe qual outro documento de planejamento de nível tático contempla a futura aquisição.
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(17)+'-2'" :name="getIdModeloArtefatoFormularioEtapa(17)+'-2'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(17)+'-2']"
                                  placeholder=""></textarea>
                        <span>Exemplo: "Plano Estratégico de Suprimentos 2025."</span>
                    </div>
                </div>
                <div :class="'carousel-item '+ (indexFormulario == 9?'active':'')">
                    <h5>
                        10 - Demonstrativo dos resultados pretendidos, em termos de economicidade e de melhor aproveitamento dos recursos humanos, materiais e financeiros disponíveis;
                    </h5>
                    <span>Economicidade e aproveitamento de recursos</span>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(18)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(18)+'-0'">
                            10.1 - Quais resultados o órgão espera alcançar com essa contratação?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(18)+'-0']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(18)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(18)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(18)+'-0']"
                                  placeholder=""></textarea>
                        <span>Descreva os benefícios diretos em termos de impacto no negócio, como melhoria no atendimento ao cidadão, maior eficiência ou redução de custos.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(18)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(18)+'-1'">
                            10.2 - Como a contratação resolverá o problema ou atenderá à necessidade identificada no tópico I?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(18)+'-1']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(18)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(18)+'-1'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(18)+'-1']"
                                  placeholder=""></textarea>
                        <span>Explique como o resultado impactará positivamente as atividades do órgão.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(18)+'-2'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(18)+'-2'">
                            10.3 - Os resultados esperados incluem impactos ambientais ou sociais positivos?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(18)+'-2']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(18)+'-2'" :name="getIdModeloArtefatoFormularioEtapa(18)+'-2'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(18)+'-2']"
                                  placeholder=""></textarea>
                        <span>Caso sim, descreva esses impactos.</span>
                        <span>Exemplo: redução de consumo de energia, diminuição de resíduos, inclusão social.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(18)+'-3'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(18)+'-3'">
                            10.4 - Os resultados pretendidos podem ser mensurados?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(18)+'-3']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(18)+'-3'" :name="getIdModeloArtefatoFormularioEtapa(18)+'-3'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(18)+'-3']"
                                  placeholder=""></textarea>
                        <span>
                            Caso sim, informe os indicadores ou métricas que serão utilizados para avaliar o sucesso da contratação.
                        </span>
                        <span>Exemplo: redução de 10% no consumo de papel ou aumento de 20% na produtividade da equipe.</span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(18)+'-4'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(18)+'-4'">
                            10.5 - Os resultados esperados são realistas, considerando o contexto da contratação?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(18)+'-4']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(18)+'-4'" :name="getIdModeloArtefatoFormularioEtapa(18)+'-4'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(18)+'-4']"
                                  placeholder=""></textarea>
                        <span>
                            Se houver dúvidas, justifique os possíveis desafios para alcançar os resultados e proponha alternativas viáveis.
                        </span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(18)+'-5'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(18)+'-5'">
                            10.6 - A equipe de planejamento validou os resultados pretendidos junto à área requisitante?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(18)+'-5']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(18)+'-5'" :name="getIdModeloArtefatoFormularioEtapa(18)+'-5'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(18)+'-5']"
                                  placeholder=""></textarea>
                        <span>
                            Informe se houve consenso ou necessidade de ajustes nas expectativas.
                        </span>
                    </div>
                </div>
                <div :class="'carousel-item '+ (indexFormulario == 10?'active':'')">
                    <h5>
                        11 - Providências a serem adotadas pela Administração previamente à celebração do contrato, tais como adaptações no ambiente do órgão ou da entidade, necessidade de obtenção de licenças, outorgas ou autorizações, capacitação
                        de servidores ou de empregados para fiscalização e gestão contratual;
                    </h5>
                    <span>Adaptações e capacitações necessárias</span>
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(19)+'-0'">
                            11.1 - Existe alguma necessidade de adaptação do órgão para que o objeto produza os efeitos esperados?
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(19)+'-0'"
                                   :name="getIdModeloArtefatoFormularioEtapa(19)+'-0'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(19)+'-0']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(19)+'-0'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(19)+'-0'"
                                   :name="getIdModeloArtefatoFormularioEtapa(19)+'-0'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(19)+'-0']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(19)+'-0'">
                                Não
                            </label>
                        </div>

                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(19)+'-0'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(19)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(19)+'-1'">
                                11.2 - Quais adaptações serão necessárias no ambiente da organização para viabilizar a implantação da solução contratada?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(19)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(19)+'-1'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(19)+'-1']"
                                      placeholder=""></textarea>
                            <span>
                                Exemplo: infraestrutura tecnológica, elétrica, ar-condicionado, espaço físico, etc.
                            </span>
                        </div>
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(19)+'-2'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(19)+'-2'">
                                11.3 - Será necessário obter licenças, outorgas ou autorizações para a execução da solução?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(19)+'-2'" :name="getIdModeloArtefatoFormularioEtapa(19)+'-2'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(19)+'-2']"
                                      placeholder=""></textarea>
                            <span>
                                Caso sim, liste quais são essas exigências e como serão obtidas.
                            </span>
                        </div>
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(19)+'-3'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(19)+'-3'">
                                11.4 - A capacitação dos servidores ou empregados será necessária para fiscalizar e gerenciar o contrato?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(19)+'-3'" :name="getIdModeloArtefatoFormularioEtapa(19)+'-3'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(19)+'-3']"
                                      placeholder=""></textarea>
                            <span>
                                Caso sim, descreva o tipo de capacitação e para quais áreas ou equipes ela será destinada.
                            </span>
                        </div>
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(19)+'-4'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(19)+'-4'">
                                11.5 - Quais serão os impactos da implantação da solução nos processos de trabalho ou na rotina dos usuários?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(19)+'-4'" :name="getIdModeloArtefatoFormularioEtapa(19)+'-4'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(19)+'-4']"
                                      placeholder=""></textarea>
                            <span>
                                Exemplo: mudanças na equipe, reorganização de fluxos de trabalho, uso de novos sistemas, etc.
                            </span>
                        </div>
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(19)+'-5'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(19)+'-5'">
                                11.6 - Quais medidas serão tomadas para gerenciar os impactos ambientais ou sociais decorrentes da implantação da solução?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(19)+'-5'" :name="getIdModeloArtefatoFormularioEtapa(19)+'-5'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(19)+'-5']"
                                      placeholder=""></textarea>
                            <span>
                                Exemplo: controle de resíduos, redução de emissões, inclusão social.
                            </span>
                        </div>
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(19)+'-6'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(19)+'-6'">
                                11.7 - Quais são as áreas ou setores responsáveis pelas adequações necessárias?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(19)+'-6'" :name="getIdModeloArtefatoFormularioEtapa(19)+'-6'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(19)+'-6']"
                                      placeholder=""></textarea>
                            <span>
                                Identifique os responsáveis por cada etapa das adaptações.
                            </span>
                        </div>
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(19)+'-7'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(19)+'-7'">
                                11.8 - Há um cronograma definido para a adequação do ambiente da organização?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(19)+'-7'" :name="getIdModeloArtefatoFormularioEtapa(19)+'-7'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(19)+'-7']"
                                      placeholder=""></textarea>
                            <span>
                                Caso sim, descreva as principais etapas e prazos.
                            </span>
                        </div>
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(19)+'-8'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(19)+'-8'">
                                11.9 - Os custos das adequações foram considerados na análise da solução a contratar?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(19)+'-8'" :name="getIdModeloArtefatoFormularioEtapa(19)+'-8'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(19)+'-8']"
                                      placeholder=""></textarea>
                            <span>
                                Caso sim, descreva como esses custos foram incluídos na avaliação.
                            </span>
                        </div>
                    </template>
                    <!----><!----><!----><!----><!----><!----><!----><!---->
                </div>
                <div :class="'carousel-item '+ (indexFormulario == 11?'active':'')">
                    <h5>
                        12 - Descrição de possíveis impactos ambientais e respectivas medidas mitigadoras, incluídos requisitos de baixo consumo de energia e de outros recursos, bem como logística reversa para desfazimento e reciclagem de bens e
                        refugos, quando aplicável;
                    </h5>
                    <span>Medidas mitigadoras e sustentabilidade</span>
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(20)+'-0'">
                            12.1 - A contratação ou o uso da solução gerará impactos ambientais?
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(20)+'-0'"
                                   :name="getIdModeloArtefatoFormularioEtapa(20)+'-0'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(20)+'-0']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(20)+'-0'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(20)+'-0'"
                                   :name="getIdModeloArtefatoFormularioEtapa(20)+'-0'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(20)+'-0']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(20)+'-0'">
                                Não
                            </label>
                        </div>
                        <span>
                            Exemplo: geração de resíduos, consumo excessivo de energia, uso de materiais não recicláveis.
                        </span>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(20)+'-0'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(20)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(20)+'-1'">
                                12.2- Os produtos ou serviços contratados estão relacionados a itens obrigados a ter logística reversa, conforme o artigo 33 da Lei 12.305/2010?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(20)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(20)+'-1'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(20)+'-1']"
                                      placeholder=""></textarea>
                            <span>
                                Caso sim, descreva como o sistema de logística reversa será estruturado.
                            </span>
                            <p>
                                Exemplo: pilhas, baterias, lâmpadas fluorescentes, produtos eletroeletrônicos.
                            </p>
                        </div>
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(20)+'-2'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(20)+'-2'">
                                12.3 - Será necessário instituir coleta seletiva cidadã como parte do contrato?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(20)+'-2'" :name="getIdModeloArtefatoFormularioEtapa(20)+'-2'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(20)+'-2']"
                                      placeholder=""></textarea>
                            <span>
                                Caso sim, indique como será implementada.
                            </span>
                        </div>
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(20)+'-3'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(20)+'-3'">
                                12.4 - Quais medidas mitigadoras serão adotadas para reduzir os impactos ambientais?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(20)+'-3'" :name="getIdModeloArtefatoFormularioEtapa(20)+'-3'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(20)+'-3']"
                                      placeholder=""></textarea>
                            <span>
                                Exemplo: substituição por materiais recicláveis, redução do consumo de energia, uso de tecnologias mais limpas.
                            </span>
                        </div>
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(20)+'-4'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(20)+'-4'">
                                12.5 - Haverá necessidade de alterar o Plano de Gerenciamento de Resíduos Sólidos do órgão para atender à solução contratada?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(20)+'-4'" :name="getIdModeloArtefatoFormularioEtapa(20)+'-4'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(20)+'-4']"
                                      placeholder=""></textarea>
                            <span>
                                Caso sim, descreva as alterações necessárias.
                            </span>
                        </div>
                    </template>
                    <!----><!----><!----><!---->
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(20)+'-5'">
                            12.6 - Os produtos ou serviços contratados atenderão a requisitos de baixo consumo de energia ou outros recursos, que foram definidos nos requisitos da contração?
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(20)+'-5'"
                                   :name="getIdModeloArtefatoFormularioEtapa(20)+'-5'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(20)+'-5']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(20)+'-5'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(20)+'-5'"
                                   :name="getIdModeloArtefatoFormularioEtapa(20)+'-5'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(20)+'-5']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(20)+'-5'">
                                Não
                            </label>
                        </div>
                        <span>
                            Exemplo: eficiência energética, economia de água.
                        </span>
                    </div>
                    <template v-if="respostas[getIdModeloArtefatoFormularioEtapa(20)+'-5'] == 'Sim'">
                        <div class="form-group ps-2 pb-2">
                            <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(20)+'-6'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(20)+'-6'">
                                12.7 - Quais requisitos ambientais específicos serão exigidos no edital ou contrato?
                            </label>
                            <textarea class="form-control mt-1"
                                      rows="2"
                                      :id="getIdModeloArtefatoFormularioEtapa(20)+'-6'" :name="getIdModeloArtefatoFormularioEtapa(20)+'-6'"
                                      v-model="respostas[getIdModeloArtefatoFormularioEtapa(20)+'-6']"
                                      placeholder=""></textarea>
                            <span>
                                Exemplo: uso de embalagens biodegradáveis, certificações ambientais, etc.
                            </span>
                        </div>
                    </template>
                    <!---->
                </div>
                <div :class="'carousel-item '+ (indexFormulario == 12?'active':'')">
                    <h5>13 - Posicionamento conclusivo sobre a adequação da contratação para o atendimento da necessidade a que se destina.</h5>
                    <span>Adequação da contratação</span>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(21)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(21)+'-0'">
                            13.1 - A contratação é viável para atender à necessidade identificada?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(21)+'-0']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(21)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(21)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(21)+'-0']"
                                  placeholder=""></textarea>
                        <span>
                            Informe se a solução proposta pode atender ao problema ou necessidade de forma adequada.
                        </span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(21)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(21)+'-1'">
                            13.2 - Qual é a justificativa para considerar a contratação viável ou inviável?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(21)+'-1']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(21)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(21)+'-1'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(21)+'-1']"
                                  placeholder=""></textarea>
                        <span>
                            Explique os principais fatores que embasam essa conclusão.
                        </span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(21)+'-2'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(21)+'-2'">
                            13.3 - Do ponto de vista técnico, a solução é viável?
                            <span>*</span>
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(21)+'-2']) }"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(21)+'-2'"
                                   :name="getIdModeloArtefatoFormularioEtapa(21)+'-2'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(21)+'-2']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(21)+'-2'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(21)+'-2']) }"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(21)+'-2'"
                                   :name="getIdModeloArtefatoFormularioEtapa(21)+'-2'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(21)+'-2']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(21)+'-2'">
                                Não
                            </label>
                        </div>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <p class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(21)+'-3'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(21)+'-3'">
                            13.4 - Existem fornecedores capazes de atender às especificações técnicas do objeto?
                            <span>*</span>
                        </p>
                        <div class="form-check">
                            <input class="form-check-input"
                                   :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(21)+'-3']) }"
                                   value="Sim" type="radio" :id="getIdModeloArtefatoFormularioEtapa(21)+'-3'"
                                   :name="getIdModeloArtefatoFormularioEtapa(21)+'-3'" true-value="Sim" v-model="respostas[getIdModeloArtefatoFormularioEtapa(21)+'-3']">
                            <label class="form-check-label" :for="getIdModeloArtefatoFormularioEtapa(21)+'-3'">
                                Sim
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input class="form-check-input"
                                   :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(21)+'-3']) }"
                                   value="Não" type="radio" :id="'check2-'+getIdModeloArtefatoFormularioEtapa(21)+'-3'"
                                   :name="getIdModeloArtefatoFormularioEtapa(21)+'-3'" true-value="Não" v-model="respostas[getIdModeloArtefatoFormularioEtapa(21)+'-3']">
                            <label class="form-check-label" :for="'check2-'+getIdModeloArtefatoFormularioEtapa(21)+'-3'">
                                Não
                            </label>
                        </div>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(21)+'-4'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(21)+'-4'">
                            13.5 - Houve análise de competitividade no mercado?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(21)+'-4']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(21)+'-4'" :name="getIdModeloArtefatoFormularioEtapa(21)+'-4'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(21)+'-4']"
                                  placeholder=""></textarea>
                        <span>
                            Explique se há empresas suficientes para garantir uma licitação competitiva.
                        </span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(21)+'-5'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(21)+'-5'">
                            13.6 - Do ponto de vista econômico, a solução é viável?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(21)+'-5']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(21)+'-5'" :name="getIdModeloArtefatoFormularioEtapa(21)+'-5'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(21)+'-5']"
                                  placeholder=""></textarea>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(21)+'-6'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(21)+'-6'">
                            13.7 - Há orçamento suficiente para custear a contratação?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(21)+'-6']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(21)+'-6'" :name="getIdModeloArtefatoFormularioEtapa(21)+'-6'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(21)+'-6']"
                                  placeholder=""></textarea>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(21)+'-7'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(21)+'-7'">
                            13.8 - Houve análise de custos para garantir a economicidade da solução?
                            <span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  :class="{ 'border-danger': validaCampo(respostas[getIdModeloArtefatoFormularioEtapa(21)+'-7']) }"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(21)+'-7'" :name="getIdModeloArtefatoFormularioEtapa(21)+'-7'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(21)+'-7']"
                                  placeholder=""></textarea>
                        <span>
                            Descreva se os custos foram analisados e comparados com alternativas viáveis.
                        </span>
                    </div>
                </div>
                <div :class="'carousel-item '+ (indexFormulario == 13?'active':'')">
                    <h5>Informações adicionais: artigos 10, 11 e 12 da instrução normativa 58/2022:</h5>
                    <span class="d-none">Adequação da contratação</span>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(22)+'-0'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(22)+'-0'">
                            O ETP contempla todos os elementos obrigatórios (I, V, VI, VII e XIII)?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(22)+'-0'" :name="getIdModeloArtefatoFormularioEtapa(22)+'-0'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(22)+'-0']"
                                  placeholder=""></textarea>
                        <span>
                            Caso não contemple, justifique a ausência e explique como as informações faltantes serão tratadas.
                        </span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(22)+'-1'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(22)+'-1'">
                            Após o levantamento de mercado, foi identificada restrição no número de fornecedores?<span>*</span>
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(22)+'-1'" :name="getIdModeloArtefatoFormularioEtapa(22)+'-1'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(22)+'-1']"
                                  placeholder=""></textarea>
                        <span>
                            Caso sim, quais requisitos limitam a participação?
                        </span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(22)+'-2'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(22)+'-2'">
                            Esses requisitos podem ser flexibilizados sem comprometer a qualidade ou os objetivos da contratação?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(22)+'-2'" :name="getIdModeloArtefatoFormularioEtapa(22)+'-2'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(22)+'-2']"
                                  placeholder=""></textarea>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(22)+'-3'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(22)+'-3'">
                            O ETP prioriza os objetivos da contratação conforme o artigo 11 da Lei 14.133/2021?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(22)+'-3'" :name="getIdModeloArtefatoFormularioEtapa(22)+'-3'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(22)+'-3']"
                                  placeholder=""></textarea>
                        <span>
                            Explique como os objetivos foram privilegiados em detrimento de exigências formais.
                        </span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(22)+'-4'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(22)+'-4'">
                            Houve contratações anteriores para atender à mesma necessidade ou uma necessidade semelhante?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(22)+'-4'" :name="getIdModeloArtefatoFormularioEtapa(22)+'-4'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(22)+'-4']"
                                  placeholder=""></textarea>
                        <span>
                            Caso sim, quais lições aprendidas ou melhorias foram identificadas com base nas contratações anteriores?
                        </span>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(22)+'-5'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(22)+'-5'">
                            Foram pesquisados ETPs de outras unidades no Sistema ETP Digital?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(22)+'-5'" :name="getIdModeloArtefatoFormularioEtapa(22)+'-5'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(22)+'-5']"
                                  placeholder=""></textarea>
                        <span>
                            Caso sim, foram identificadas soluções semelhantes que poderiam atender à demanda?
                        </span>
                        <p>
                            Caso não, justifique a ausência dessa pesquisa.
                        </p>
                    </div>
                    <div class="form-group ps-2 pb-2">
                        <label class="gradient-text text-dark color-gradient mt-2" :for="getIdModeloArtefatoFormularioEtapa(22)+'-6'" :id="'pergunta-'+getIdModeloArtefatoFormularioEtapa(22)+'-6'">
                            O ETP precisa ser classificado conforme a Lei 12.527/2011 (Lei de Acesso à Informação)?
                        </label>
                        <textarea class="form-control mt-1"
                                  rows="2"
                                  :id="getIdModeloArtefatoFormularioEtapa(22)+'-6'" :name="getIdModeloArtefatoFormularioEtapa(22)+'-6'"
                                  v-model="respostas[getIdModeloArtefatoFormularioEtapa(22)+'-6']"
                                  placeholder=""></textarea>
                        <span>
                            Caso sim, qual o nível de sigilo atribuído ao documento?
                        </span>
                    </div>
                </div>

            </div>
                </div>
                <div v-if="painelPncpAberto" class="dfd-painel-pncp">
                    <div class="dfd-painel-pncp-header">
                        <div>
                            <h6 class="dfd-painel-pncp-titulo">
                                Resultados do PNCP
                                <span v-if="loadingPncp"
                                      class="spinner-border spinner-border-sm text-primary dfd-painel-pncp-header-spinner"
                                      role="status"
                                      aria-label="Buscando no PNCP"></span>
                            </h6>
                            <p class="dfd-painel-pncp-subtitulo">
                                {{ loadingPncp ? 'Buscando no PNCP...' : 'Clique em uma ou mais opções para preencher o levantamento de mercado' }}
                            </p>
                        </div>
                        <div class="dfd-painel-pncp-acoes">
                            <button v-if="buscaPncpConcluida && !loadingPncp"
                                    type="button"
                                    class="btn btn-outline-primary btn-sm"
                                    :disabled="!flPermissao"
                                    @click="buscarNovamentePncp">
                                Buscar novamente
                            </button>
                            <button type="button"
                                    class="dfd-painel-pncp-fechar"
                                    title="Fechar"
                                    aria-label="Fechar painel PNCP"
                                    @click="fecharPainelPncp">
                                &times;
                            </button>
                        </div>
                    </div>

                    <div v-if="loadingPncp" class="dfd-painel-pncp-loading">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Carregando...</span>
                        </div>
                        <p class="mt-3 mb-0">Buscando no PNCP...</p>
                    </div>

                    <div v-else class="dfd-painel-pncp-resultado">
                        <div v-if="temResultadosPncp" class="dfd-pncp-grupos">
                            <template v-for="(grupo, grupoIndex) in lstObjetosPncp">
                                <section v-if="grupo.resultados && grupo.resultados.length"
                                         :key="'pncp-grupo-' + grupoIndex"
                                         class="dfd-pncp-grupo"
                                         :class="{ 'is-open': grupoPncpAberto(grupoIndex) }">
                                    <button type="button"
                                            class="dfd-pncp-grupo-titulo"
                                            :aria-expanded="grupoPncpAberto(grupoIndex) ? 'true' : 'false'"
                                            @click="alternarGrupoPncp(grupoIndex)">
                                        <span class="dfd-pncp-grupo-titulo-texto">{{ formatarNomeGrupoPncp(grupo.nome) }}</span>
                                        <span class="dfd-pncp-grupo-meta">{{ grupo.resultados.length }}</span>
                                        <span class="dfd-pncp-grupo-chevron" aria-hidden="true"></span>
                                    </button>
                                    <div v-show="grupoPncpAberto(grupoIndex)"
                                         class="dfd-pncp-lista"
                                         role="listbox"
                                         :aria-label="formatarNomeGrupoPncp(grupo.nome)">
                                        <button v-for="(opcao, opcaoIndex) in grupo.resultados"
                                                :key="'pncp-opcao-' + grupoIndex + '-' + opcaoIndex"
                                                type="button"
                                                class="dfd-pncp-opcao"
                                                role="option"
                                                :aria-selected="opcaoPncpSelecionada(grupoIndex, opcaoIndex)"
                                                :class="{ 'is-selected': opcaoPncpSelecionada(grupoIndex, opcaoIndex) }"
                                                @click="selecionarObjetoPncp(opcao, grupoIndex, opcaoIndex, grupo.nome)">
                                            <span class="dfd-pncp-opcao-radio" aria-hidden="true"></span>
                                            <span class="dfd-pncp-opcao-conteudo">
                                                <span class="dfd-pncp-opcao-texto">{{ textoOpcaoPncp(opcao) }}</span>
                                                <a v-if="linkOpcaoPncp(opcao)"
                                                   class="dfd-pncp-opcao-link"
                                                   :href="linkOpcaoPncp(opcao)"
                                                   target="_blank"
                                                   rel="noopener noreferrer"
                                                   @click.stop>
                                                    Ver fonte
                                                </a>
                                                <span class="dfd-pncp-opcao-acao">
                                                    {{ opcaoPncpSelecionada(grupoIndex, opcaoIndex) ? 'Selecionado' : 'Selecionar' }}
                                                </span>
                                            </span>
                                        </button>
                                    </div>
                                </section>
                            </template>
                        </div>
                        <div v-else class="dfd-painel-pncp-vazio">
                            <p class="mb-0">{{ mensagemVaziaPncp }}</p>
                            <span>Verifique o objeto no DFD e tente novamente.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row align-items-center">
            <div class="col-6 text-start">
                <button class="btn btn-light me-3" v-if="indexFormulario > 0" @click="indexFormulario -=1">Anterior</button>
            </div>
            <div class="col-6 text-end">
                <button class="btn btn-light ms-3"
                        @click="irParaProximaEtapa"
                        v-if="indexFormulario < (lstEtapas.length -1)">
                    Próximo
                </button>

            </div>
            <div class="col-12 text-center mt-3">
                <button :class="(flPermissao?'btn btn-primary ms-3':'btn btn-outline-light ms-3')"
                        @click="(flPermissao?salvaForm():null)"
                        :disabled="!flPermissao">
                    Salvar Formulário
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import $ from 'jquery'
    import Swal from 'sweetalert2'

    export default {
        name: 'formETP',
        components: { },
        data: function () {
            return {
                indexFormulario: 0,
                indexUltimaEtapaAvancada: 0,

                // 'idModeloArtefatoFormularioEtapa' - 'cdFormulario'
                respostas: {
                    '10-0': '', '10-1': '', '10-2': '', '10-3': '',
                    '11-0': '', '11-1': '', '11-2': '', '11-3': '', '11-4': '', '11-5': '','11-6': '','11-7': '','11-8': '','11-9': '','11-10': '','11-11': '','11-12': '',
                    '12-0': '','12-1': '','12-2': '','12-3': '','12-4': '','12-5': '','12-6': '',
                    '12-7': '', '12-8': '', '12-9': '', '12-10': '', '12-11': '', '12-12': '', '12-13': '', '12-14': '', '12-15': '',
                    '13-0': '','13-1': '','13-2': '','13-3': '','13-4': '','13-5': '','13-6': '','13-7': '','13-8': '',
                    '13-9': '', '13-10': '', '13-11': '', '13-12': '', '13-13': '', '13-14': '', '13-15': '', '13-16': '', '13-17': '', '13-18': '', '13-19': '', '13-20': '', '13-21': '', '13-22': '', '13-23': '', '13-24': '', '13-25': '',
                    '14-0': '', '14-1': '', '14-2': '', '14-3': '',
                    '15-0': '', '15-1': '', '15-2': '', '15-3': '', '15-4': '', '15-5': '', '15-6': '',
                    '16-0': '', '16-1': '', '16-2': '', '16-3': '', '16-4': '', '16-5': '', '16-6': '', '16-7': '', '16-8': '', '16-9': '', '16-10': '', '16-11': '', '16-12': '', '16-13': '', '16-14': '',
                    '17-0': '', '17-1': '', '17-2': '', '17-3': '', '17-4': '', '17-5': '',
                    '18-0': '', '18-1': '', '18-2': '',
                    '19-0': '', '19-1': '', '19-2': '', '19-3': '', '19-4': '', '19-5': '',
                    '20-0': '','20-1': '','20-2': '','20-3': '','20-4': '','20-5': '','20-6': '','20-7': '','20-8': '',
                    '21-0': '', '21-1': '', '21-2': '', '21-3': '', '21-4': '', '21-5': '', '21-6': '', '21-7': '',
                    '22-0': '','22-1': '','22-2': '','22-3': '','22-4': '','22-5': '','22-6': '','22-7': '','22-8': '','22-9': '',
                    '23-0': '','23-1': '','23-2': '','23-3': '','23-4': '','23-5': '','23-6': '',
                },
                lstRespostaBanco: null,

                lstEtapas: [],
                itensDetalhados: null,

                temRequisicaoCompra: false,
                emProcessamento: false,
                flPodeCancelarProcessamento: false,
                cancelarProcessamentoLoading: false,
                intervaloStatus: null,
                painelPncpAberto: false,
                loadingPncp: false,
                lstObjetosPncp: [],
                gruposPncpAbertos: {},
                chavesObjetosPncpSelecionados: [],
                opcoesPncpSelecionadas: {},
                intervaloBuscaPncp: null,
                buscaPncpConcluida: false,
                mensagemVaziaPncp: 'Nenhum resultado encontrado no PNCP.',
            }
        },
        props: {
            idModeloArtefato: Number,
            idProcesso: Number,
            idProcessoModeloArtefato: Number,
            flPermissao: Boolean,
        },
        computed: {
            podeCancelarProcessamento() {
                return this.emProcessamento && this.flPodeCancelarProcessamento;
            },
            temResultadosPncp() {
                return (this.lstObjetosPncp || []).some(grupo =>
                    grupo && Array.isArray(grupo.resultados) && grupo.resultados.length > 0
                );
            },
        },
        methods: {
            validaCampo(valor) {
                if (this.lstRespostaBanco == null || this.lstRespostaBanco.length == 0) {
                    return false;
                } else {
                    return valor == '' || valor == undefined || valor == null;
                }
            },

            grupoPncpAberto(grupoIndex) {
                return !!(this.gruposPncpAbertos && this.gruposPncpAbertos[grupoIndex]);
            },

            alternarGrupoPncp(grupoIndex) {
                const aberto = this.grupoPncpAberto(grupoIndex);
                this.$set(this.gruposPncpAbertos, grupoIndex, !aberto);
            },

            resetarGruposPncpAbertos() {
                this.gruposPncpAbertos = {};
            },

            load() {
                this.indexFormulario = 0;
                this.indexUltimaEtapaAvancada = 0;
                this.respostas = {
                    '10-0': '', '10-1': '', '10-2': '', '10-3': '',
                    '11-0': '', '11-1': '', '11-2': '', '11-3': '', '11-4': '', '11-5': '', '11-6': '', '11-7': '', '11-8': '', '11-9': '', '11-10': '', '11-11': '', '11-12': '',
                    '12-0': '', '12-1': '', '12-2': '', '12-3': '', '12-4': '', '12-5': '', '12-6': '',
                    '12-7': '', '12-8': '', '12-9': '', '12-10': '', '12-11': '', '12-12': '', '12-13': '', '12-14': '', '12-15': '',
                    '13-0': '', '13-1': '', '13-2': '', '13-3': '', '13-4': '', '13-5': '', '13-6': '', '13-7': '', '13-8': '',
                    '13-9': '', '13-10': '', '13-11': '', '13-12': '', '13-13': '', '13-14': '', '13-15': '', '13-16': '', '13-17': '', '13-18': '', '13-19': '', '13-20': '', '13-21': '', '13-22': '', '13-23': '', '13-24': '', '13-25': '',
                    '14-0': '', '14-1': '', '14-2': '', '14-3': '',
                    '15-0': '', '15-1': '', '15-2': '', '15-3': '', '15-4': '', '15-5': '', '15-6': '',
                    '16-0': '', '16-1': '', '16-2': '', '16-3': '', '16-4': '', '16-5': '', '16-6': '', '16-7': '', '16-8': '', '16-9': '', '16-10': '', '16-11': '', '16-12': '', '16-13': '', '16-14': '',
                    '17-0': '', '17-1': '', '17-2': '', '17-3': '', '17-4': '', '17-5': '',
                    '18-0': '', '18-1': '', '18-2': '',
                    '19-0': '', '19-1': '', '19-2': '', '19-3': '', '19-4': '', '19-5': '',
                    '20-0': '', '20-1': '', '20-2': '', '20-3': '', '20-4': '', '20-5': '', '20-6': '', '20-7': '', '20-8': '',
                    '21-0': '', '21-1': '', '21-2': '', '21-3': '', '21-4': '', '21-5': '', '21-6': '', '21-7': '',
                    '22-0': '', '22-1': '', '22-2': '', '22-3': '', '22-4': '', '22-5': '', '22-6': '', '22-7': '', '22-8': '', '22-9': '',
                    '23-0': '', '23-1': '', '23-2': '', '23-3': '', '23-4': '', '23-5': '', '23-6': '',
                };
                this.lstRespostaBanco = null;
                this.lstEtapas = [];

                this.temRequisicaoCompra = false;
                this.getEtapas();
                this.carregaFormulario();
                this.getStatusProcessamento();
                this.verificarRequisicaoCompra();
                
            },

            getIdModeloArtefatoFormularioEtapa(cdEtapa) {
                return this.lstEtapas.find(x => x.cdEtapa == cdEtapa)?.idModeloArtefatoFormularioEtapa;
            },

            getCdEtapa(idModeloArtefatoFormularioEtapa) {
                return this.lstEtapas.find(x => x.idModeloArtefatoFormularioEtapa == idModeloArtefatoFormularioEtapa)?.cdEtapa;
            },

            irParaProximaEtapa() {
                this.indexUltimaEtapaAvancada = this.indexFormulario + 1;
                this.indexFormulario += 1;
            },

            navegarParaEtapa(index) {
                this.indexFormulario = index;
                this.indexUltimaEtapaAvancada = this.indexFormulario;
            },

            limparFormsInativos() {
                if ((this.respostas[this.getIdModeloArtefatoFormularioEtapa(10) + '-2'] != 'Sim' || this.respostas[this.getIdModeloArtefatoFormularioEtapa(10) + '-2'] =='' ) && 
                    (this.respostas[this.getIdModeloArtefatoFormularioEtapa(10) + '-3'] != 'Sim'
                    || this.respostas[this.getIdModeloArtefatoFormularioEtapa(10) + '-3'] == '') &&
                    (this.respostas[this.getIdModeloArtefatoFormularioEtapa(10) + '-4'] != 'Sim'
                        || this.respostas[this.getIdModeloArtefatoFormularioEtapa(10) + '-4'] == '')
                ) {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(10) + '-5'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(10) + '-11'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(10) + '-12'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(11) + '-1'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(11) + '-2'] = '';
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(11) + '-3'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(11) + '-8'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(11) + '-9'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(11) + '-10'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(11) + '-11'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(11) + '-10'] != 'Não') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(11) + '-12'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(11) + '-13'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(11) + '-14'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(11) + '-13'] != 'Não') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(11) + '-15'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(12) + '-9'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(12) + '-10'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(12) + '-11'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(12) + '-12'] = '';
                }
                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(12) + '-13'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(12) + '-14'] = '';
                }
                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(12) + '-15'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(12) + '-16'] = '';
                }
                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(12) + '-17'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(12) + '-18'] = '';
                }
                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(12) + '-21'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(12) + '-22'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(12) + '-24'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(12) + '-25'] = '';
                }
                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(13) + '-4'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(13) + '-5'] = '';
                }
                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(13) + '-6'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(13) + '-7'] = '';
                }
                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(13) + '-6'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(13) + '-7'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(15) + '-0'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(15) + '-6'] = '';
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(15) + '-7'] = '';
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(15) + '-8'] = '';
                }

                //if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(15) + '-7'] != 'Não') {
                //    this.respostas[this.getIdModeloArtefatoFormularioEtapa(15) + '-8'] = '';
                //}

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(15) + '-0'] != 'Não') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(15) + '-9'] = '';
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(15) + '-10'] = '';
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(15) + '-11'] = '';
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(15) + '-12'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(16) + '-0'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(16) + '-1'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(16) + '-2'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(16) + '-3'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(16) + '-2'] != 'Não') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(16) + '-5'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(17) + '-0'] != 'Não') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(17) + '-1'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(19) + '-0'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(19) + '-1'] = '';
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(19) + '-2'] = '';
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(19) + '-3'] = '';
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(19) + '-4'] = '';
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(19) + '-5'] = '';
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(19) + '-6'] = '';
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(19) + '-7'] = '';
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(19) + '-8'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(20) + '-0'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(20) + '-1'] = '';
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(20) + '-2'] = '';
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(20) + '-3'] = '';
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(20) + '-4'] = '';
                }

                if (this.respostas[this.getIdModeloArtefatoFormularioEtapa(20) + '-5'] != 'Sim') {
                    this.respostas[this.getIdModeloArtefatoFormularioEtapa(20) + '-6'] = '';
                }
            },

            salvaForm() {
                this.salvaFormulario(true);
            },

            salvaFormulario(exibirFeedback) {
                let $this = this;
                $this.limparFormsInativos();
                const formData = new FormData();
                if (Object.entries($this.respostas).length > 0 ){
                    var cont = 0;
                    Object.entries($this.respostas).forEach(([index, resposta]) => {
                        let idModeloArtefatoFormularioEtapa = index.split('-')[0];
                        let cdFormulario = index.split('-')[1];

                        let ModeloArtefatoFormularioEtapa = ($this.lstRespostaBanco || []).find(x => x.idModeloArtefatoFormularioEtapa == idModeloArtefatoFormularioEtapa && x.cdFormulario == cdFormulario);

                        formData.append('form[' + cont + '].idProcessoArtefatoFormularioResposta', (ModeloArtefatoFormularioEtapa ? ModeloArtefatoFormularioEtapa.idProcessoArtefatoFormularioResposta : 0));
                        formData.append('form[' + cont + '].idModeloArtefatoFormularioEtapa', idModeloArtefatoFormularioEtapa);
                        formData.append('form[' + cont + '].cdFormulario', cdFormulario);
                        if (resposta != undefined && resposta.trim() != '') {
                            formData.append('form[' + cont + '].dsResposta', resposta);
                        }
                        formData.append('form[' + cont + '].idProcesso', $this.idProcesso);
                        formData.append('form[' + cont + '].idProcessoModeloArtefato', $this.idProcessoModeloArtefato);
                        formData.append('form[' + cont + '].dsPergunta', $('#pergunta-' + index).text());
                        cont++;
                    });

                } else {
                    avisoErro("Preencha o formulário");
                    return Promise.resolve(false);
                }

                return axios.post(`${urlApi}/ProcessoArtefatoFormulario/Post`, formData, { headers: { "Content-Type": `multipart/form-data; boundary=${formData._boundary}`, } })
                    .then(res => {
                        if (res.data.success) {
                            if (exibirFeedback) {
                                avisoToast("Formulário registrado com sucesso.");
                                $this.load();
                            }
                            return true;
                        } else {
                            avisoErro("Não foi possível enviar o artefato.");
                            return false;
                        }
                    })
                    .catch(res => {
                        $this.msgErro = 'Não foi possível enviar o artefato.';
                        if (res.response && res.response.data) {
                            $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                            avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                        } else {
                            avisoErro("Não foi possível enviar o artefato.");
                        }
                        return false;
                    });
            },

            carregaFormulario() {
                let $this = this;
                axios.get(`${urlApi}/ProcessoArtefatoFormulario/Get/`, { showLoading: true, params: { idProcesso: $this.idProcesso, idProcessoModeloArtefato: $this.idProcessoModeloArtefato } })
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.lstRespostaBanco = result;
                            for (let i = 0; i < result.length; i++) {
                                let item = result[i];
                                //$this.respostas[item.idModeloArtefatoFormularioEtapa + '-' + item.cdFormulario] = item.dsResposta;
                                $this.$set($this.respostas, item.idModeloArtefatoFormularioEtapa + '-' + item.cdFormulario, (item.dsResposta == null ? '' : item.dsResposta));
                            }
                            $this.getItensDetalhados();
                        } else {
                            avisoErro("Não foi possível carregar os dados do formulário.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro("Não foi possível carregar os dados do formulário.");
                        }
                    });
            },

            getEtapas() {
                let $this = this;

                axios.get(`${urlApi}/ProcessoArtefatoFormulario/GetEtapas/`, { showLoading: true, params: { idModeloArtefato: $this.idModeloArtefato } })
                    .then(res => {
                        $this.lstProcessoArtefatoHistorico = null;
                        if (res.data.success) {
                            var result = res.data.data;

                            $this.lstEtapas = result;

                        } else {
                            avisoErro("Não foi possível carregar as etapas.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro("Não foi possível carregar as etapas.");
                        }
                    });
            },

            getItensDetalhados() {
                let $this = this;
                return axios.get(`${urlApi}/ProcessoItem/GetItensDetalhados`, {
                    params: { idProcesso: this.idProcesso }
                })
                    .then(res => {
                        if (res.data && res.data.data && res.data.data.rows) {
                            $this.itensDetalhados = res.data.data.rows;

                            if ($this.itensDetalhados.length > 0) {
                                var descricaoItens = '', descricaoDetalhada = '', unidadeMedida = '', quantidade = '', preco = '';

                                var loteUnico = true;
                                var loteAtual = undefined;
                                $this.itensDetalhados.forEach((item) => {
                                    if (loteAtual == undefined) {
                                        loteAtual = item.lote;
                                    }
                                    if (loteAtual != item.lote) {
                                        loteUnico = false;
                                    }
                                    loteAtual = item.lote;
                                });

                                $this.itensDetalhados.forEach((item) => {
                                    var sigiloso = item.flValorSigiloso === true || item.flValorSigiloso === 1;
                                    var textoUnitario = sigiloso ? 'sigiloso' : ('R$ ' + $this.formatarNumero(item.valorUnitario));
                                    var textoTotal = sigiloso ? 'sigiloso' : ('R$ ' + $this.formatarNumero(item.valorTotal));
                                    descricaoItens += ' '
                                        + item.nome +
                                        (!loteUnico ? ' - Lote: ' + item.lote : '')+
                                        ' - Quantidade: ' + (item.qtdItemCriacao > 0 ? $this.formatarNumero(item.qtdItemCriacao) : $this.formatarNumero(item.quantidade)) + +
                                        ' - Unidade de Medida: ' + item.unidadeMedida +
                                        ' - Valor Unitário: ' + textoUnitario +
                                        ' - Valor Total: ' + textoTotal +
                                        (item.nmUnidade != "" && item.nmUnidade != null ? ' - Unidade Responsável: ' + item.nmUnidade : '') +
                                        (item.dtDesejadaItem != "" && item.dtDesejadaItem != null ? ' - Data desejada: ' + this.formatarData(item.dtDesejadaItem) : '') +
                                        (item.dsGrauPrioridade != "" && item.dsGrauPrioridade != null ? ' - Grau de prioridade: ' + item.dsGrauPrioridade : '') +
                                        (item.flEnvolvePostoTrabalho != "" && item.flEnvolvePostoTrabalho != null ? ' - Envolve posto de trabalho: ' + (item.flEnvolvePostoTrabalho == 1 ? 'Sim' : 'Não') : '') +
                                        (item.nrProcessoContratacao != "" && item.nrProcessoContratacao != null ? ' - Número do processo de contratação: ' + item.nrProcessoContratacao : '') +
                                        (item.nrProcessoVinculacao != "" && item.nrProcessoVinculacao != null ? ' - Vinculação a outras contratações: ' + item.nrProcessoVinculacao : '') +
                                        (item.dsJustificativa != "" && item.dsJustificativa != null ? ' - Justificativa: ' + item.dsJustificativa : '') +
                                        ' ; \n';

                                    descricaoDetalhada += ' '
                                        + item.nome +
                                        (!loteUnico ? ' - Lote: ' + item.lote : '') +
                                        ' - Quantidade: ' + (item.qtdItemCriacao > 0 ? $this.formatarNumero(item.qtdItemCriacao) : $this.formatarNumero(item.quantidade)) + +
                                        ' - Unidade de Medida: ' + item.unidadeMedida +
                                        ' - Valor Unitário: ' + textoUnitario +
                                        ' - Valor Total: ' + textoTotal +
                                        (item.nmUnidade != "" && item.nmUnidade != null ? ' - Unidade Responsável: ' + item.nmUnidade : '') +
                                        (item.dtDesejadaItem != "" && item.dtDesejadaItem != null ? ' - Data desejada: ' + this.formatarData(item.dtDesejadaItem) : '') +
                                        (item.dsGrauPrioridade != "" && item.dsGrauPrioridade != null ? ' - Grau de prioridade: ' + item.dsGrauPrioridade : '') +
                                        (item.flEnvolvePostoTrabalho != "" && item.flEnvolvePostoTrabalho != null ? ' - Envolve posto de trabalho: ' + (item.flEnvolvePostoTrabalho == 1 ? 'Sim' : 'Não') : '') +
                                        (item.nrProcessoContratacao != "" && item.nrProcessoContratacao != null ? ' - Número do processo de contratação: ' + item.nrProcessoContratacao : '') +
                                        (item.nrProcessoVinculacao != "" && item.nrProcessoVinculacao != null ? ' - Vinculação a outras contratações: ' + item.nrProcessoVinculacao : '') +
                                        (item.dsJustificativa != "" && item.dsJustificativa != null ? ' - Justificativa: ' + item.dsJustificativa : '') +
                                        ' ; \n';

                                    unidadeMedida += ' '
                                        + item.nome +
                                        (!loteUnico ? ' - Lote: ' + item.lote : '') +
                                        ' - Unidade de Medida: ' + item.unidadeMedida +
                                        ' ; \n';

                                    quantidade += ' '
                                        + item.nome +
                                        (!loteUnico ? ' - Lote: ' + item.lote : '') +
                                        ' - Quantidade: ' + (item.qtdItemCriacao > 0 ? $this.formatarNumero(item.qtdItemCriacao) : $this.formatarNumero(item.quantidade)) + +
                                        ' ; \n';

                                    preco += ' '
                                        + item.nome +
                                        (!loteUnico ? ' - Lote: ' + item.lote : '') +
                                        ' - Valor Unitário: ' + textoUnitario +
                                        ' ; \n';

                                });
                                if ($this.respostas[$this.getIdModeloArtefatoFormularioEtapa(13) + '-0'] == '') {
                                    $this.$set($this.respostas, $this.getIdModeloArtefatoFormularioEtapa(13) + '-0', descricaoItens);
                                } 
                                if ($this.respostas[$this.getIdModeloArtefatoFormularioEtapa(14) + '-0'] == '') {
                                    $this.$set($this.respostas, $this.getIdModeloArtefatoFormularioEtapa(14) + '-0', descricaoDetalhada);
                                }
                                if ($this.respostas[$this.getIdModeloArtefatoFormularioEtapa(14) + '-1'] == '') {
                                    $this.$set($this.respostas, $this.getIdModeloArtefatoFormularioEtapa(14) + '-1', unidadeMedida);
                                }
                                if ($this.respostas[$this.getIdModeloArtefatoFormularioEtapa(14) + '-2'] == '') {
                                    $this.$set($this.respostas, $this.getIdModeloArtefatoFormularioEtapa(14) + '-2', quantidade);
                                }
                                if ($this.respostas[$this.getIdModeloArtefatoFormularioEtapa(14) + '-3'] == '') {
                                    $this.$set($this.respostas, $this.getIdModeloArtefatoFormularioEtapa(14) + '-3', preco);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar os itens do processo.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro ao buscar os itens do processo.");
                    });
            },

            formatarNumero(valor, casasDecimais = 2) {
                if (typeof valor !== 'number') {
                    valor = parseFloat(valor);
                }
                if (isNaN(valor)) return '';

                return valor.toLocaleString('pt-BR', {
                    minimumFractionDigits: casasDecimais,
                    maximumFractionDigits: casasDecimais,
                });
            },

            formatarData(valor) {
                if (!valor) return ''
                const d = new Date(valor)
                return d.toLocaleDateString('pt-BR')
            },

            verificarRequisicaoCompra() {
                if (!this.idProcesso) {
                    this.temRequisicaoCompra = false;
                    return;
                }

                axios.get(`${urlApi}/RequisicaoCompra/GetPorProcesso`, {
                    showLoading: false,
                    params: { idProcesso: this.idProcesso },
                })
                    .then(res => {
                        const idRequisicaoCompra = res.data && res.data.success && res.data.data
                            ? res.data.data.idRequisicaoCompra
                            : 0;
                        this.temRequisicaoCompra = idRequisicaoCompra > 0;
                    })
                    .catch(() => {
                        this.temRequisicaoCompra = false;
                    });
            },

            async preencherIA() {
                let $this = this;
                const podeGerar = await this.VerificaArtefatos();
                if (!podeGerar) return;

                Swal.fire({
                    title: 'Confirmar geração das respostas por IA',
                    html: `Esta ação utilizará inteligência artificial para gerar automaticamente as respostas com base nos documentos enviados.<br><br> Caso o formulário já tenha sido preenchido, as respostas existentes serão substituídas.<br><br>
           Deseja continuar?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#1f7bff',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, gerar por IA',
                    cancelButtonText: 'Cancelar'

                }).then(async (result) => {
                    if (result.isConfirmed) {
                        const salvou = await $this.salvaFormulario(false);
                        if (!salvou) return;

                        axios.post(`${urlApi}/ProcessoArtefatoFormulario/PreencherIA/`, { idProcesso: this.idProcesso, idProcessoModeloArtefato: $this.idProcessoModeloArtefato })
                            .then(res => {
                                if (res.data.success) {
                                    $this.load();
                                } else {
                                    avisoErro("Não foi possível carregar as respostas.");
                                }
                            })
                            .catch(() => {
                                avisoErro("Não foi possível carregar as respostas.");
                            });
                    }
                });
               
            },

            async preencherPorRequisicao() {
                let $this = this;
                const podeGerar = await this.VerificaArtefatosPorRequisicao();
                if (!podeGerar) return;

                Swal.fire({
                    title: 'Confirmar preenchimento a partir da requisição',
                    html: `Esta ação utilizará a requisição de compra vinculada para gerar automaticamente as respostas.<br><br> Caso o formulário já tenha sido preenchido, as respostas existentes serão substituídas.<br><br>
           Deseja continuar?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#1f7bff',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, preencher',
                    cancelButtonText: 'Cancelar'

                }).then(async (result) => {
                    if (result.isConfirmed) {
                        const salvou = await $this.salvaFormulario(false);
                        if (!salvou) return;

                        axios.post(`${urlApi}/ProcessoArtefatoFormulario/PreencherPorRequisicao/`, { idProcesso: this.idProcesso, idProcessoModeloArtefato: $this.idProcessoModeloArtefato })
                            .then(res => {
                                if (res.data.success) {
                                    $this.load();
                                } else {
                                    avisoErro("Não foi possível carregar as respostas.");
                                }
                            })
                            .catch(() => {
                                avisoErro("Não foi possível carregar as respostas.");
                            });
                    }
                });
               
            },

            getStatusProcessamento(showLoading = true) {
                axios.get(`${urlApi}/ProcessoArtefatoFormulario/GetStatusProcessamento/`, { showLoading: showLoading, params: { idProcesso: this.idProcesso, idProcessoModeloArtefato: this.idProcessoModeloArtefato } })
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;

                            this.emProcessamento = false;
                            this.flPodeCancelarProcessamento = false;
                            if (result && result.idProcessoArtefatoFormularioProcessamento) {
                                const emAndamento = typeof result.emAndamento === 'boolean'
                                    ? result.emAndamento
                                    : (result.dsStatus != 'Finalizada' && result.dsStatus != 'Cancelada');
                                if (emAndamento) {
                                    this.emProcessamento = true;
                                    this.flPodeCancelarProcessamento = !!result.flPodeCancelar;
                                    this.iniciarMonitoramentoStatus();
                                } else {
                                    this.emProcessamento = false;
                                    this.pararMonitoramentoStatus();
                                    this.carregaFormulario();
                                }
                            } else {
                                this.emProcessamento = false;
                                this.pararMonitoramentoStatus();
                                this.carregaFormulario();
                            }

                        } else {
                            avisoErro("Não foi possível carregar status do processamento.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Não foi possível carregar status do processamento.");
                    });
            },

            confirmarCancelarProcessamento() {
                Swal.fire({
                    title: 'Cancelar processamento?',
                    html: 'O preenchimento com IA em andamento será cancelado por possível travamento. Depois você poderá tentar novamente.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d97706',
                    cancelButtonText: 'Voltar',
                    confirmButtonText: 'Sim, cancelar processamento',
                    reverseButtons: true,
                }).then(result => {
                    if (result.isConfirmed) this.cancelarProcessamentoTravado();
                });
            },

            cancelarProcessamentoTravado() {
                if (this.cancelarProcessamentoLoading) return;
                this.cancelarProcessamentoLoading = true;
                axios.post(`${urlApi}/ProcessoArtefatoFormulario/CancelarProcessamentoTravado`, {
                    idProcesso: this.idProcesso,
                    idProcessoModeloArtefato: this.idProcessoModeloArtefato,
                }, { showLoading: true })
                    .then(res => {
                        if (res.data && res.data.success) {
                            avisoToast(res.data.msg || 'Processamento cancelado com sucesso.', 'success');
                            this.emProcessamento = false;
                            this.flPodeCancelarProcessamento = false;
                            this.pararMonitoramentoStatus();
                            this.getStatusProcessamento(false);
                        } else {
                            avisoErro((res.data && res.data.msg) || 'Não foi possível cancelar o processamento.');
                        }
                    })
                    .catch(err => {
                        const msg = (err.response && err.response.data && err.response.data.errors && err.response.data.errors[0])
                            || (err.response && err.response.data && err.response.data.msg)
                            || err.message
                            || 'Não foi possível cancelar o processamento.';
                        avisoErro(msg);
                    })
                    .finally(() => {
                        this.cancelarProcessamentoLoading = false;
                    });
            },
            iniciarMonitoramentoStatus() {
                if (this.intervaloStatus) return;

                this.intervaloStatus = setInterval(() => {
                    this.getStatusProcessamento(false);
                }, 10000);
            },

            pararMonitoramentoStatus() {
                if (!this.intervaloStatus) return;

                clearInterval(this.intervaloStatus);
                this.intervaloStatus = null;
            },

            VerificaArtefatos() {
                return axios.get(`${urlApi}/ProcessoArtefato/GetArtefatos`, {
                    params: {
                        idProcesso: this.idProcesso
                    }
                })
                    .then(res => {
                        if (!res.data.success || !res.data.data) {
                            avisoErro("Erro ao buscar os artefatos do processo.");
                            return false;
                        }

                        const artefatos = res.data.data || [];
                        if (artefatos.length === 0) {
                            avisoErro("Para realizar a geração por IA, é necessário o upload dos documentos DFD nos artefatos do processo.");
                            return false;
                        }

                        const temDFD = artefatos.some(a => a.idProcessoModeloArtefato === 1);
                        //const temETP = artefatos.some(a => a.idProcessoModeloArtefato === 2);
                        const temETP = true;

                        if (!temDFD || !temETP) {
                            let faltando = [];
                            if (!temDFD) faltando.push("DFD");
                            if (!temETP) faltando.push("ETP");

                            avisoErro(`Ainda faltam os seguintes documentos para permitir a geração por IA: ${faltando.join(" e ")}.`);
                            return false;
                        }

                        return true;
                    })
                    .catch(() => {
                        avisoErro("Erro na requisição de verificação de artefatos.");
                        return false;
                    });
            },

            VerificaArtefatosPorRequisicao() {
                return axios.get(`${urlApi}/ProcessoArtefato/GetArtefatos`, {
                    params: {
                        idProcesso: this.idProcesso
                    }
                })
                    .then(res => {
                        if (!res.data.success || !res.data.data) {
                            avisoErro("Erro ao buscar os artefatos do processo.");
                            return false;
                        }

                        const artefatos = res.data.data || [];
                        if (artefatos.length === 0) {
                            avisoErro("Para preencher a partir da requisição, é necessário o upload dos documentos DFD nos artefatos do processo.");
                            return false;
                        }

                        const temDFD = artefatos.some(a => a.idProcessoModeloArtefato === 1);
                        const temETP = true;

                        if (!temDFD || !temETP) {
                            let faltando = [];
                            if (!temDFD) faltando.push("DFD");
                            if (!temETP) faltando.push("ETP");

                            avisoErro(`Ainda faltam os seguintes documentos para permitir o preenchimento a partir da requisição: ${faltando.join(" e ")}.`);
                            return false;
                        }

                        return true;
                    })
                    .catch(() => {
                        avisoErro("Erro na requisição de verificação de artefatos.");
                        return false;
                    });
            },

            buscarNoPncp() {
                this.painelPncpAberto = true;
                this.loadingPncp = true;
                this.lstObjetosPncp = [];
                this.limparSelecoesPncp();
                this.buscaPncpConcluida = false;
                this.mensagemVaziaPncp = 'Nenhum resultado encontrado no PNCP.';
                this.pararMonitoramentoBuscaPncp();

                axios.get(`${urlApi}/ProcessoBuscaPNCP/Get`, {
                    showLoading: false,
                    params: { idProcesso: this.idProcesso, idProcessoModeloArtefato: this.idProcessoModeloArtefato },
                })
                    .then(res => {
                        if (!res.data || !res.data.success) {
                            this.iniciarNovaBuscaPncp();
                            return;
                        }

                        const data = res.data.data || {};
                        const busca = data.ProcessoBuscaPNCP || data.processoBuscaPNCP;

                        if (!busca) {
                            this.iniciarNovaBuscaPncp();
                            return;
                        }

                        const dsResposta = busca.dsResposta;
                        if (dsResposta == null || dsResposta === '') {
                            this.loadingPncp = true;
                            this.buscaPncpConcluida = false;
                            this.iniciarMonitoramentoBuscaPncp();
                            return;
                        }

                        this.aplicarResultadoBuscaPncp(data, dsResposta);
                    })
                    .catch(() => {
                        this.iniciarNovaBuscaPncp();
                    });
            },

            buscarNovamentePncp() {
                this.buscaPncpConcluida = false;
                this.limparSelecoesPncp();
                this.iniciarNovaBuscaPncp();
            },

            obterObjetoDfd() {
                return axios.get(`${urlApi}/ProcessoArtefatoFormulario/Get/`, {
                    showLoading: false,
                    params: {
                        idProcesso: this.idProcesso,
                        idProcessoModeloArtefato: 1,
                    },
                })
                    .then(res => {
                        if (!res.data || !res.data.success) {
                            return '';
                        }

                        const rows = Array.isArray(res.data.data) ? res.data.data : [];
                        const porPergunta = rows.find(item => {
                            const pergunta = (item.dsPergunta || '').toLowerCase();
                            return pergunta.includes('objeto da contratação') || pergunta.includes('qual o objeto');
                        });

                        if (porPergunta && porPergunta.dsResposta) {
                            return String(porPergunta.dsResposta).trim();
                        }

                        return '';
                    })
                    .catch(() => '');
            },

            iniciarNovaBuscaPncp() {
                this.loadingPncp = true;
                this.lstObjetosPncp = [];
                this.buscaPncpConcluida = false;

                this.obterObjetoDfd()
                    .then(dsObjeto => {
                        if (!dsObjeto) {
                            this.loadingPncp = false;
                            avisoErro('Preencha o objeto da contratação no DFD antes de buscar no PNCP.');
                            return;
                        }

                        return axios.post(`${urlApi}/ProcessoBuscaPNCP/buscaObjetoPncp`, {
                            dsObjeto,
                            idProcesso: this.idProcesso,
                            idProcessoModeloArtefato: this.idProcessoModeloArtefato,
                        }, { showLoading: false })
                            .then(res => {
                                if (res.data && res.data.success) {
                                    this.iniciarMonitoramentoBuscaPncp();
                                    this.getStatusBuscaPncp();
                                } else {
                                    this.loadingPncp = false;
                                    avisoErro((res.data && res.data.msg) || 'Não foi possível buscar no PNCP.');
                                }
                            });
                    })
                    .catch(err => {
                        this.loadingPncp = false;
                        const msg = (err && err.response && err.response.data && err.response.data.errors && err.response.data.errors[0])
                            || (err && err.response && err.response.data && err.response.data.msg)
                            || (err && err.message)
                            || 'Não foi possível buscar no PNCP.';
                        avisoErro(msg);
                    });
            },

            aplicarResultadoBuscaPncp(data, dsResposta) {
                this.loadingPncp = false;
                this.buscaPncpConcluida = true;
                this.pararMonitoramentoBuscaPncp();
                this.resetarGruposPncpAbertos();

                if (typeof dsResposta === 'string' && dsResposta.trim() === 'Não foi possível realizar busca') {
                    this.lstObjetosPncp = [];
                    this.mensagemVaziaPncp = 'Não foram encontradas respostas no PNCP.';
                    return;
                }

                const formatada = data.dsRepostaFormatada
                    || data.dsRespostaFormatada
                    || [];

                this.lstObjetosPncp = Array.isArray(formatada) ? formatada : [];
                this.mensagemVaziaPncp = 'Nenhum resultado encontrado no PNCP.';
            },

            getStatusBuscaPncp() {
                axios.get(`${urlApi}/ProcessoBuscaPNCP/Get`, {
                    showLoading: false,
                    params: { idProcesso: this.idProcesso, idProcessoModeloArtefato: this.idProcessoModeloArtefato },
                })
                    .then(res => {
                        if (!res.data || !res.data.success) {
                            return;
                        }

                        const data = res.data.data || {};
                        const busca = data.ProcessoBuscaPNCP || data.processoBuscaPNCP;
                        if (!busca) {
                            this.loadingPncp = false;
                            this.lstObjetosPncp = [];
                            this.pararMonitoramentoBuscaPncp();
                            return;
                        }

                        const dsResposta = busca.dsResposta;
                        if (dsResposta == null || dsResposta === '') {
                            this.loadingPncp = true;
                            return;
                        }

                        this.aplicarResultadoBuscaPncp(data, dsResposta);
                    })
                    .catch(() => {
                        // Mantém o polling em caso de falha pontual.
                    });
            },

            iniciarMonitoramentoBuscaPncp() {
                if (this.intervaloBuscaPncp) return;
                this.intervaloBuscaPncp = setInterval(() => {
                    this.getStatusBuscaPncp();
                }, 5000);
            },

            pararMonitoramentoBuscaPncp() {
                if (!this.intervaloBuscaPncp) return;
                clearInterval(this.intervaloBuscaPncp);
                this.intervaloBuscaPncp = null;
            },

            formatarNomeGrupoPncp(nome) {
                const mapa = {
                    sugestoes_objeto: 'Sugestões de objeto',
                    sugestoes_itens: 'Sugestões de itens',
                    levantamento_mercado: 'Levantamento de mercado',
                    justificativa_tecnica: 'Justificativa técnica',
                    justificativa_economica: 'Justificativa econômica',
                };
                if (!nome) return 'Resultados';
                if (mapa[nome]) return mapa[nome];
                return String(nome)
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, (letra) => letra.toUpperCase());
            },

            chaveOpcaoPncp(grupoIndex, opcaoIndex) {
                return `${grupoIndex}-${opcaoIndex}`;
            },

            opcaoPncpSelecionada(grupoIndex, opcaoIndex) {
                return (this.chavesObjetosPncpSelecionados || []).includes(this.chaveOpcaoPncp(grupoIndex, opcaoIndex));
            },

            limparSelecoesPncp() {
                this.chavesObjetosPncpSelecionados = [];
                this.opcoesPncpSelecionadas = {};
            },

            tipoGrupoPncp(nome) {
                const n = (nome || '').toString().trim().toLowerCase();
                if (n === 'justificativa_tecnica') return 'tecnica';
                if (n === 'justificativa_economica') return 'economica';
                return 'mercado';
            },

            textoOpcaoPncp(opcao) {
                if (typeof opcao === 'string') return opcao;
                if (!opcao || typeof opcao !== 'object') return '';
                return opcao.resultado || opcao.texto || '';
            },

            textoOpcaoPncpNormalizado(opcao) {
                return (this.textoOpcaoPncp(opcao) || '').trim().toLowerCase();
            },

            idPncpOpcao(opcao) {
                if (!opcao || typeof opcao !== 'object') return '';
                return (opcao.idPNCP || '').toString().trim().toLowerCase();
            },

            linkOpcaoPncp(opcao) {
                if (!opcao || typeof opcao !== 'object') return '';
                return opcao.url || opcao.link || '';
            },

            textoReferenciaPncp(opcao) {
                if (!opcao || typeof opcao !== 'object') return '';
                const partes = [];
                if (opcao.idPNCP) partes.push(`ID PNCP: ${opcao.idPNCP}`);
                if (opcao.unidadeCompradora) partes.push(`Unidade compradora: ${opcao.unidadeCompradora}`);
                const url = this.linkOpcaoPncp(opcao);
                if (url) partes.push(`URL: ${url}`);
                return partes.join('\n');
            },

            textoCustoBeneficioPncp(opcao) {
                if (!opcao || typeof opcao !== 'object') return '';
                return (opcao.custoBeneficio || opcao.CustoBeneficio || '').toString().trim();
            },

            montarItensUnicosPncp(opcoes) {
                const sugestoesUnicas = [];
                const referenciasUnicas = [];
                const custosBeneficiosUnicos = [];
                const textosVistos = new Set();
                const idsVistos = new Set();

                (opcoes || []).forEach(opcao => {
                    const textoNorm = this.textoOpcaoPncpNormalizado(opcao);
                    const idNorm = this.idPncpOpcao(opcao);
                    if ((textoNorm && textosVistos.has(textoNorm)) || (idNorm && idsVistos.has(idNorm))) {
                        return;
                    }
                    if (textoNorm) textosVistos.add(textoNorm);
                    if (idNorm) idsVistos.add(idNorm);

                    const sugestao = this.textoOpcaoPncp(opcao);
                    const referencia = this.textoReferenciaPncp(opcao);
                    const custoBeneficio = this.textoCustoBeneficioPncp(opcao);
                    if (sugestao) sugestoesUnicas.push(sugestao);
                    if (referencia) referenciasUnicas.push(referencia);
                    if (custoBeneficio) custosBeneficiosUnicos.push(custoBeneficio);
                });

                return { sugestoesUnicas, referenciasUnicas, custosBeneficiosUnicos };
            },

            textoJaInseridoNoFormularioPncp(textoNormalizado, campos) {
                if (!textoNormalizado || !campos || !campos.length) return false;
                return campos.some(campo => {
                    if (!campo) return false;
                    return String(campo)
                        .split(/\n\n+/)
                        .map(parte => parte.trim().toLowerCase())
                        .filter(Boolean)
                        .includes(textoNormalizado);
                });
            },

            opcaoPncpJaInserida(opcao, chaveIgnorar = null, nomeGrupo = null) {
                const texto = this.textoOpcaoPncpNormalizado(opcao);
                const idPncp = this.idPncpOpcao(opcao);
                if (!texto && !idPncp) return false;

                const tipo = this.tipoGrupoPncp(nomeGrupo || (opcao && opcao.nomeGrupo));
                const jaSelecionada = (this.chavesObjetosPncpSelecionados || []).some(chave => {
                    if (chaveIgnorar && chave === chaveIgnorar) return false;
                    const outra = this.opcoesPncpSelecionadas[chave];
                    if (!outra) return false;
                    if (this.tipoGrupoPncp(outra.nomeGrupo) !== tipo) return false;
                    if (texto && this.textoOpcaoPncpNormalizado(outra) === texto) return true;
                    if (idPncp && this.idPncpOpcao(outra) === idPncp) return true;
                    return false;
                });
                if (jaSelecionada) return true;

                const idEtapa3 = this.getIdModeloArtefatoFormularioEtapa(11);
                let campos = [];
                if (tipo === 'tecnica') {
                    campos = [this.respostas[idEtapa3 + '-5']];
                } else if (tipo === 'economica') {
                    campos = [this.respostas[idEtapa3 + '-6']];
                } else {
                    campos = [
                        this.respostas[idEtapa3 + '-0'],
                        this.respostas[idEtapa3 + '-3'],
                    ];
                }
                return this.textoJaInseridoNoFormularioPncp(texto, campos);
            },

            irParaEtapaLevantamentoMercado() {
                this.indexFormulario = 2;
                if (this.indexUltimaEtapaAvancada < 2) {
                    this.indexUltimaEtapaAvancada = 2;
                }
            },

            aplicarSelecoesPncpNoFormulario() {
                const idEtapa3 = this.getIdModeloArtefatoFormularioEtapa(11);
                const idEtapa4 = this.getIdModeloArtefatoFormularioEtapa(12);
                const opcoes = (this.chavesObjetosPncpSelecionados || [])
                    .map(chave => this.opcoesPncpSelecionadas[chave])
                    .filter(Boolean);

                const mercado = [];
                const tecnica = [];
                const economica = [];

                opcoes.forEach(opcao => {
                    const tipo = this.tipoGrupoPncp(opcao.nomeGrupo);
                    if (tipo === 'tecnica') tecnica.push(opcao);
                    else if (tipo === 'economica') economica.push(opcao);
                    else mercado.push(opcao);
                });
                
                const mercadoUnico = this.montarItensUnicosPncp(mercado);
                if (mercado.length === 0) {
                    this.$set(this.respostas, idEtapa3 + '-0', '');
                    this.$set(this.respostas, idEtapa3 + '-1', '');
                    this.$set(this.respostas, idEtapa3 + '-2', '');
                    this.$set(this.respostas, idEtapa3 + '-3', '');
                    this.$set(this.respostas, idEtapa3 + '-7', '');
                    this.$set(this.respostas, idEtapa4 + '-0', '');
                } else {
                    this.$set(this.respostas, idEtapa3 + '-0', mercadoUnico.sugestoesUnicas.join('\n\n'));
                    this.$set(this.respostas, idEtapa3 + '-1', 'Sim');
                    this.$set(this.respostas, idEtapa3 + '-2', mercadoUnico.referenciasUnicas.join('\n\n'));
                    this.$set(this.respostas, idEtapa3 + '-3', mercadoUnico.sugestoesUnicas.join('\n\n'));
                    this.$set(this.respostas, idEtapa3 + '-7', mercadoUnico.custosBeneficiosUnicos.join('\n\n'));
                    this.$set(this.respostas, idEtapa4 + '-0', mercadoUnico.referenciasUnicas.join('\n\n'));
                }

                const tecnicaUnica = this.montarItensUnicosPncp(tecnica);
                this.$set(this.respostas, idEtapa3 + '-5', tecnicaUnica.sugestoesUnicas.join('\n\n'));

                const economicaUnica = this.montarItensUnicosPncp(economica);
                this.$set(this.respostas, idEtapa3 + '-6', economicaUnica.sugestoesUnicas.join('\n\n'));
            },

            selecionarObjetoPncp(opcao, grupoIndex, opcaoIndex, nomeGrupo = null) {
                const chave = this.chaveOpcaoPncp(grupoIndex, opcaoIndex);
                const indice = (this.chavesObjetosPncpSelecionados || []).indexOf(chave);

                if (indice >= 0) {
                    this.chavesObjetosPncpSelecionados.splice(indice, 1);
                    this.$delete(this.opcoesPncpSelecionadas, chave);
                    avisoToast('Opção removida da seleção do PNCP.', 'success');
                } else {
                    if (this.opcaoPncpJaInserida(opcao, chave, nomeGrupo)) {
                        avisoToast('Esta opção já foi incluída e não pode ser selecionada novamente.');
                        return;
                    }

                    const itemSelecionado = typeof opcao === 'string'
                        ? { resultado: opcao, nomeGrupo: nomeGrupo || '' }
                        : Object.assign({}, opcao, { nomeGrupo: nomeGrupo || '' });

                    this.chavesObjetosPncpSelecionados.push(chave);
                    this.$set(this.opcoesPncpSelecionadas, chave, itemSelecionado);
                    avisoToast('Opção selecionada do PNCP.', 'success');
                }

                this.aplicarSelecoesPncpNoFormulario();
                this.irParaEtapaLevantamentoMercado();
            },

            fecharPainelPncp() {
                this.pararMonitoramentoBuscaPncp();
                this.painelPncpAberto = false;
                this.loadingPncp = false;
                this.lstObjetosPncp = [];
                this.limparSelecoesPncp();
                this.buscaPncpConcluida = false;
            },
        },
        mounted: function () {
            this.load();
        },
        beforeDestroy: function () {
            this.pararMonitoramentoBuscaPncp();
            this.pararMonitoramentoStatus();
        },
        watch: {
            idModeloArtefato: function () {
                this.load();
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .border-danger {
        border-color: #E8B6C1 !important;
        box-shadow: 0 0 0 0.2rem rgba(196, 104, 110, 0.25);
    }

    .importacao-em-andamento-container {
        display: flex;
        justify-content: center;
        align-items: center;
        /*min-height: calc(100vh - 260px);*/
        padding: 28px 16px 0px;
    }

    .importacao-em-andamento-card {
        width: 100%;
        max-width: 100%;
        background: #ffffff;
        border-radius: 18px;
        border: 1px solid rgba(226, 232, 240, 0.95);
        box-shadow: 0 16px 42px rgba(15, 23, 42, 0.08);
        padding: 20px 15px;
        text-align: center;
    }

    .importacao-em-andamento-icon {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin: 0 auto 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        color: #ffffff;
        animation: pulseImportacao 1.8s ease-in-out infinite;
    }

    .importacao-em-andamento-card h2 {
        margin: 0 0 8px;
        font-size: 1.6rem;
        font-weight: 700;
        color: #0f172a;
    }

    .importacao-em-andamento-card p {
        /*margin: 0 auto;*/
        max-width: 620px;
        font-size: 1rem;
        color: #475569;
    }

    .importacao-em-andamento-actions {
        /*margin-top: 20px;*/
        /*margin-bottom: 8px;*/
        display: flex;
        justify-content: center;
    }

    .importacao-em-andamento-card small {
        display: block;
        margin-top: 2px;
        color: #64748b;
        font-size: 0.86rem;
    }

    .dfd-conteudo {
        display: flex;
        align-items: flex-start;
        gap: 1rem;
        width: 100%;
    }

    .dfd-conteudo--com-pncp {
        position: relative;
        display: block;
    }

    .dfd-formulario {
        width: 100%;
        min-width: 0;
        transition: width 0.25s ease;
    }

    .dfd-conteudo--com-pncp .dfd-formulario {
        width: calc(60% - 0.5rem);
    }

    .dfd-painel-pncp {
        width: 40%;
        flex: 0 0 40%;
        min-height: 280px;
        display: flex;
        flex-direction: column;
        border: 1px solid rgba(226, 232, 240, 0.95);
        border-radius: 14px;
        background: #ffffff;
        box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
        overflow: hidden;
    }

    .dfd-conteudo--com-pncp .dfd-painel-pncp {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: calc(40% - 0.5rem);
        min-height: 0;
        height: auto;
    }

    .dfd-painel-pncp-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 12px;
        padding: 16px 16px 12px;
        border-bottom: 1px solid #eef2f7;
        background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
        flex-shrink: 0;
    }

    .dfd-painel-pncp-titulo {
        margin: 0;
        font-size: 0.98rem;
        font-weight: 700;
        color: #0f172a;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .dfd-painel-pncp-header-spinner {
        width: 0.9rem;
        height: 0.9rem;
        border-width: 0.15em;
        flex-shrink: 0;
    }

    .dfd-painel-pncp-subtitulo {
        margin: 4px 0 0;
        font-size: 0.82rem;
        color: #64748b;
    }

    .dfd-painel-pncp-acoes {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-shrink: 0;
    }

    .dfd-painel-pncp-fechar {
        width: 32px;
        height: 32px;
        border: none;
        border-radius: 8px;
        background: transparent;
        color: #64748b;
        font-size: 1.4rem;
        line-height: 1;
        cursor: pointer;
        flex-shrink: 0;
        transition: background 0.15s ease, color 0.15s ease;
    }

    .dfd-painel-pncp-fechar:hover {
        background: #f1f5f9;
        color: #0f172a;
    }

    .dfd-painel-pncp-loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        flex: 1 1 auto;
        min-height: 0;
        padding: 32px 16px 24px;
        color: #475569;
        text-align: center;
    }

    .dfd-painel-pncp-resultado {
        flex: 1 1 auto;
        min-height: 0;
        padding: 12px;
        overflow-y: auto;
    }

    .dfd-pncp-grupos {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .dfd-pncp-grupo {
        border: 1px solid #e2e8f0;
        border-radius: 12px;
        background: #fff;
        overflow: hidden;
    }

    .dfd-pncp-grupo-titulo {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        margin: 0;
        padding: 12px 14px;
        border: 0;
        background: #f8fafc;
        font-size: 0.8rem;
        font-weight: 700;
        letter-spacing: 0.02em;
        text-transform: uppercase;
        text-align: left;
        color: #64748b;
        cursor: pointer;
        transition: background 0.15s ease, color 0.15s ease;
    }

    .dfd-pncp-grupo-titulo:hover {
        background: #f1f5f9;
        color: #475569;
    }

    .dfd-pncp-grupo.is-open .dfd-pncp-grupo-titulo {
        color: #334155;
        border-bottom: 1px solid #e2e8f0;
    }

    .dfd-pncp-grupo-titulo-texto {
        flex: 1 1 auto;
        min-width: 0;
    }

    .dfd-pncp-grupo-meta {
        flex: 0 0 auto;
        min-width: 22px;
        padding: 2px 7px;
        border-radius: 999px;
        background: #e2e8f0;
        color: #475569;
        font-size: 0.72rem;
        font-weight: 700;
        line-height: 1.2;
        text-align: center;
    }

    .dfd-pncp-grupo-chevron {
        flex: 0 0 auto;
        width: 8px;
        height: 8px;
        border-right: 2px solid #94a3b8;
        border-bottom: 2px solid #94a3b8;
        transform: rotate(45deg);
        transition: transform 0.15s ease;
        margin-left: 2px;
    }

    .dfd-pncp-grupo.is-open .dfd-pncp-grupo-chevron {
        transform: rotate(-135deg);
        margin-top: 4px;
    }

    .dfd-pncp-lista {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 10px;
        max-height: min(320px, 45vh);
        overflow-x: hidden;
        overflow-y: auto;
        overscroll-behavior: contain;
        -webkit-overflow-scrolling: touch;
    }

    .dfd-pncp-opcao {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        width: 100%;
        text-align: left;
        padding: 12px 14px;
        border: 1px solid #e2e8f0;
        border-radius: 12px;
        background: #fff;
        color: #1e293b;
        cursor: pointer;
        transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
    }

    .dfd-pncp-opcao:hover {
        border-color: #93c5fd;
        background: #f8fbff;
        box-shadow: 0 4px 14px rgba(37, 99, 235, 0.08);
        transform: translateY(-1px);
    }

    .dfd-pncp-opcao:focus-visible {
        outline: 2px solid #2563eb;
        outline-offset: 2px;
    }

    .dfd-pncp-opcao.is-selected {
        border-color: #2563eb;
        background: #eff6ff;
        box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.2);
    }

    .dfd-pncp-opcao-radio {
        width: 18px;
        height: 18px;
        margin-top: 2px;
        border: 2px solid #cbd5e1;
        border-radius: 50%;
        flex-shrink: 0;
        transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
    }

    .dfd-pncp-opcao:hover .dfd-pncp-opcao-radio {
        border-color: #60a5fa;
    }

    .dfd-pncp-opcao.is-selected .dfd-pncp-opcao-radio {
        border-color: #2563eb;
        background: #2563eb;
        box-shadow: inset 0 0 0 3px #eff6ff;
    }

    .dfd-pncp-opcao-conteudo {
        display: flex;
        flex-direction: column;
        gap: 6px;
        min-width: 0;
        flex: 1;
    }

    .dfd-pncp-opcao-texto {
        font-size: 0.92rem;
        line-height: 1.45;
        color: #0f172a;
        word-break: break-word;
    }

    .dfd-pncp-opcao-link {
        font-size: 0.8rem;
        font-weight: 600;
        color: #2563eb;
        text-decoration: none;
        width: fit-content;
    }

    .dfd-pncp-opcao-link:hover {
        text-decoration: underline;
    }

    .dfd-pncp-opcao-acao {
        font-size: 0.75rem;
        font-weight: 600;
        letter-spacing: 0.01em;
        color: #64748b;
        text-transform: uppercase;
    }

    .dfd-pncp-opcao:hover .dfd-pncp-opcao-acao {
        color: #2563eb;
    }

    .dfd-pncp-opcao.is-selected .dfd-pncp-opcao-acao {
        color: #1d4ed8;
    }

    .dfd-painel-pncp-vazio {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 6px;
        min-height: 100%;
        padding: 24px 16px;
        text-align: center;
        color: #64748b;
        font-size: 0.9rem;
    }

    .dfd-painel-pncp-vazio span {
        font-size: 0.8rem;
        color: #94a3b8;
    }
</style>

